(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3078],{

/***/ 61620:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Extension"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Extension"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"service"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":53}}');
    doc.loc.source = JSON.parse('{"body":"fragment Extension on Extension {\\n  type\\n  service\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 35060:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SupportType"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"SupportType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":52}}');
    doc.loc.source = JSON.parse('{"body":"fragment SupportType on SupportType {\\n  id\\n  name\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 95572:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderKey"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderKey"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tagId"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":56}}');
    doc.loc.source = JSON.parse('{"body":"fragment WorkOrderKey on WorkOrderKey {\\n  key\\n  tagId\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

      module.exports = doc;
    


/***/ }),

/***/ 36604:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"andonCallCancel"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"andonCallCancel"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"directives":[]}]}}],"loc":{"start":0,"end":106}}');
    doc.loc.source = JSON.parse('{"body":"mutation andonCallCancel($id: ID!, $companyId: ID!) {\\n  andonCallCancel(id: $id, companyId: $companyId)\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.andonCallCancel = oneQuery(doc, "andonCallCancel");
        


/***/ }),

/***/ 18469:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"andonCallRelease"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"andonCallRelease"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"take"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":205}}');
    doc.loc.source = JSON.parse('{"body":"mutation andonCallRelease($id: ID!, $companyId: ID!) {\\n  andonCallRelease(id: $id, companyId: $companyId) {\\n    id\\n    action {\\n      take {\\n        time\\n        author\\n        details\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.andonCallRelease = oneQuery(doc, "andonCallRelease");
        


/***/ }),

/***/ 62650:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"andonCallReopen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"resolutionTime"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"andonCallReopen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"resolutionTime"},"value":{"kind":"Variable","name":{"kind":"Name","value":"resolutionTime"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolve"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":263}}');
    doc.loc.source = JSON.parse('{"body":"mutation andonCallReopen($id: ID!, $companyId: ID!, $resolutionTime: Date!) {\\n  andonCallReopen(id: $id, companyId: $companyId, resolutionTime: $resolutionTime) {\\n    id\\n    action {\\n      resolve {\\n        time\\n        author\\n        details\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.andonCallReopen = oneQuery(doc, "andonCallReopen");
        


/***/ }),

/***/ 95039:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"andonCallResolve"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"details"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"author"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"andonCallResolve"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"details"}}},{"kind":"Argument","name":{"kind":"Name","value":"author"},"value":{"kind":"Variable","name":{"kind":"Name","value":"author"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolve"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":281}}');
    doc.loc.source = JSON.parse('{"body":"mutation andonCallResolve($id: ID!, $companyId: ID!, $details: String!, $author: String!) {\\n  andonCallResolve(id: $id, companyId: $companyId, details: $details, author: $author) {\\n    id\\n    action {\\n      resolve {\\n        time\\n        author\\n        details\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.andonCallResolve = oneQuery(doc, "andonCallResolve");
        


/***/ }),

/***/ 67231:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"andonCallTake"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"author"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"andonCallTake"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"author"},"value":{"kind":"Variable","name":{"kind":"Name","value":"author"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"take"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":233}}');
    doc.loc.source = JSON.parse('{"body":"mutation andonCallTake($companyId: ID!, $id: ID!, $author: String) {\\n  andonCallTake(companyId: $companyId, id: $id, author: $author) {\\n    id\\n    action {\\n      take {\\n        time\\n        author\\n        details\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.andonCallTake = oneQuery(doc, "andonCallTake");
        


/***/ }),

/***/ 12846:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"andonCallWorkOrderInitiate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"details"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"author"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"andonCallWorkOrderInitiate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callId"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tagId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagId"}}},{"kind":"Argument","name":{"kind":"Name","value":"details"},"value":{"kind":"Variable","name":{"kind":"Name","value":"details"}}},{"kind":"Argument","name":{"kind":"Name","value":"author"},"value":{"kind":"Variable","name":{"kind":"Name","value":"author"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pending"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":361}}');
    doc.loc.source = JSON.parse('{"body":"mutation andonCallWorkOrderInitiate($callId: ID!, $companyId: ID!, $tagId: ID!, $details: String!, $author: String!) {\\n  andonCallWorkOrderInitiate(\\n    callId: $callId\\n    companyId: $companyId\\n    tagId: $tagId\\n    details: $details\\n    author: $author\\n  ) {\\n    id\\n    action {\\n      pending {\\n        time\\n        author\\n        details\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.andonCallWorkOrderInitiate = oneQuery(doc, "andonCallWorkOrderInitiate");
        


/***/ }),

/***/ 62165:
/***/ (function(module) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"andonListCalls"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"time"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Date"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"andon"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extensions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"service"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"calls"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"time"},"value":{"kind":"Variable","name":{"kind":"Name","value":"time"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"line"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"requestedSupport"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"role"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"urgency"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"action"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"make"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"take"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"resolve"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"pending"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"author"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"time"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":665}}');
    doc.loc.source = JSON.parse('{"body":"query andonListCalls($time: Date) {\\n  andon {\\n    companyId\\n    extensions {\\n      type\\n      service\\n    }\\n    calls(time: $time) {\\n      id\\n      line {\\n        id\\n        name\\n        description\\n      }\\n      requestedSupport\\n      role {\\n        name\\n      }\\n      urgency\\n      action {\\n        make {\\n          author\\n          details\\n          time\\n        }\\n        take {\\n          author\\n          details\\n          time\\n        }\\n        resolve {\\n          author\\n          details\\n          time\\n        }\\n        pending {\\n          author\\n          details\\n          time\\n        }\\n      }\\n      tags {\\n        id\\n        value\\n      }\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.andonListCalls = oneQuery(doc, "andonListCalls");
        


/***/ }),

/***/ 32889:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"andonListSettings"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"andon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extensions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Extension"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"supportTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SupportType"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":304}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/andon-legacy/extension.gql\'\\n#import \'@/graphql/fragments/andon-legacy/support-type.gql\'\\n\\nquery andonListSettings($companyId: [ID!]) {\\n  andon(companyId: $companyId) {\\n    companyId\\n    extensions {\\n      ...Extension\\n    }\\n    supportTypes {\\n      ...SupportType\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(61620).definitions)));
doc.definitions = doc.definitions.concat(unique((__webpack_require__(35060).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.andonListSettings = oneQuery(doc, "andonListSettings");
        


/***/ }),

/***/ 84275:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = JSON.parse('{"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"andonListWorkOrderKeys"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"andon"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lineId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lineId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"workOrderKeys"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tagIds"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tagIds"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkOrderKey"},"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":316}}');
    doc.loc.source = JSON.parse('{"body":"#import \'@/graphql/fragments/andon-legacy/work-order-key.gql\'\\n\\nquery andonListWorkOrderKeys($companyId: [ID!], $lineId: ID!, $tagIds: [ID!]) {\\n  andon(companyId: $companyId) {\\n    companyId\\n    tags(lineId: $lineId) {\\n      id\\n      value\\n    }\\n    workOrderKeys(tagIds: $tagIds) {\\n      ...WorkOrderKey\\n    }\\n  }\\n}\\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}}');
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(95572).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports.andonListWorkOrderKeys = oneQuery(doc, "andonListWorkOrderKeys");
        


/***/ }),

/***/ 16885:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/andon",
      function () {
        return __webpack_require__(14854);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 73773:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88149);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99758);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8942);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44143);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var react_csv__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84012);
/* harmony import */ var _hooks_use_translation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59721);










var ExportCsvButton = function(props) {
    var id = props.id, headers = props.headers, data = props.data, filename = props.filename, style = props.style, fullWidth = props.fullWidth, onClick = props.onClick, buttonText = props.buttonText;
    var t = (0,_hooks_use_translation__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)([
        "shared"
    ]).t;
    var theme = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    if (!data) {
        return null;
    }
    var processedData = data.map(function(row) {
        return Object.entries(row).reduce(function(processedRow, param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
            processedRow[key] = (0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(value, Date) ? value.getTime() : value;
            return processedRow;
        }, {});
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_csv__WEBPACK_IMPORTED_MODULE_2__.CSVLink, {
        onClick: onClick,
        data: processedData,
        headers: headers,
        filename: "".concat(filename.toLocaleLowerCase(), ".csv"),
        target: "_blank",
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            textDecoration: "none",
            color: theme.palette.text.primary,
            margin: "10px"
        }, style),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            title: t([
                "shared:exportCsvTooltio"
            ], {
                defaultValue: "Export data to CSV. Only data displayed above is exported."
            }),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                id: id,
                variant: "contained",
                color: "primary",
                fullWidth: fullWidth,
                children: buttonText !== null && buttonText !== void 0 ? buttonText : t([
                    "shared:exportCsv"
                ], {
                    defaultValue: "Export CSV"
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ExportCsvButton);


/***/ }),

/***/ 72615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ ExportExcel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88149);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48417);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78344);
/* harmony import */ var _mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8942);
/* harmony import */ var _progress_kendo_react_excel_export__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2825);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29901);











var isArrayOfTableHeaderArrays = function(headers) {
    return headers.length > 0 && Array.isArray(headers[0]);
};
var ExportExcelButton = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ExportExcelButton, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ExportExcelButton);
    function ExportExcelButton() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ExportExcelButton);
        return _super.apply(this, arguments);
    }
    var _proto = ExportExcelButton.prototype;
    _proto.render = function render() {
        var _props = this.props, data = _props.data, name = _props.name, t = _props.t, style = _props.style, fullWidth = _props.fullWidth, buttonText = _props.buttonText, headers = _props.headers;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExportExcel, {
            data: data !== null && data !== void 0 ? data : [],
            name: name,
            headers: headers,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Tooltip__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: t([
                    "shared:exportExcelTooltio"
                ], {
                    defaultValue: "Export data to Excel. Only data displayed above is exported."
                }),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    id: this.props.id,
                    style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        margin: "10px"
                    }, style),
                    variant: "contained",
                    color: "primary",
                    fullWidth: fullWidth,
                    children: buttonText !== null && buttonText !== void 0 ? buttonText : t([
                        "shared:exportExcel"
                    ], {
                        defaultValue: "Export Excel"
                    })
                })
            })
        });
    };
    return ExportExcelButton;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (ExportExcelButton);
// NOTE: Including spacing between lines
var fontSize = 20;
var ExportExcel = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ExportExcel, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ExportExcel);
    function ExportExcel() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ExportExcel);
        var _this;
        _this = _super.apply(this, arguments);
        _this._exporters = [];
        _this.export = function() {
            var component = _this._exporters[0];
            if (!component) {
                return;
            }
            var options = component.workbookOptions();
            _this._exporters.forEach(function(exp, i) {
                var ref, ref1;
                if (!exp) {
                    return;
                }
                var additionalSheetOptions = exp.workbookOptions();
                if (!options.sheets || !additionalSheetOptions.sheets) {
                    return;
                }
                options.sheets[i] = additionalSheetOptions.sheets[0];
                options.sheets[i].name = (ref = _this.props.data) === null || ref === void 0 ? void 0 : (ref1 = ref[i]) === null || ref1 === void 0 ? void 0 : ref1.name;
                var rows = options.sheets[i].rows || [];
                var cols = options.sheets[i].columns || [];
                // Check each cell in each row for objects and transform them.
                rows.forEach(function(row) {
                    var _Math;
                    var lines = (_Math = Math).max.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((row.cells || []).map(function(c) {
                        var ref;
                        return typeof c.value === "string" ? ((ref = c.value.match(/\n/g)) === null || ref === void 0 ? void 0 : ref.length) || 1 : 1;
                    })));
                    row.height = fontSize * lines;
                    if (row.type === "data") {
                        (row.cells || []).forEach(function(cell, i) {
                            cell.verticalAlign = "top";
                            cell.wrap = true;
                            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(cell.value, Date)) {
                                cell.format = "YYYY/mm/dd hh:mm:ss";
                                cols[i].autoWidth = false;
                                cols[i].width = cell.format.length * 8;
                            }
                            if (typeof cell.value === "object" && cell.value !== null) {
                                var obj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, cell.value);
                                Object.keys(obj).map(function(key) {
                                    cell[key] = obj[key];
                                });
                            }
                        });
                    }
                });
            });
            component.save(options);
        };
        return _this;
    }
    var _proto = ExportExcel.prototype;
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, data = _props.data, name = _props.name, children = _props.children, style = _props.style, headers = _props.headers;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            onClick: this.export,
            style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, style),
            children: [
                children,
                data === null || data === void 0 ? void 0 : data.map(function(d, i) {
                    var sheetHeaders = headers && isArrayOfTableHeaderArrays(headers) ? headers[i] : headers;
                    var ref, _label;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_progress_kendo_react_excel_export__WEBPACK_IMPORTED_MODULE_1__/* .ExcelExport */ .jY, {
                        data: (ref = d === null || d === void 0 ? void 0 : d.data) !== null && ref !== void 0 ? ref : [],
                        fileName: "".concat(name.toLocaleLowerCase(), ".xlsx"),
                        ref: function(exporter) {
                            return _this._exporters[i] = exporter;
                        },
                        children: sheetHeaders === null || sheetHeaders === void 0 ? void 0 : sheetHeaders.map(function(header) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_progress_kendo_react_excel_export__WEBPACK_IMPORTED_MODULE_1__/* .ExcelExportColumn */ .AW, {
                                field: header.key,
                                title: (_label = header.label) !== null && _label !== void 0 ? _label : header.key
                            }, "".concat(header.key));
                        })
                    }, "".concat(i, "-export"));
                })
            ]
        });
    };
    return ExportExcel;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);


/***/ }),

/***/ 86489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_CardContent__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24267);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14517);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5887);













var styles = function(theme) {
    return {
        responsive: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, theme.breakpoints.down("md"), {
            padding: theme.spacing(),
            "&:last-child": {
                paddingBottom: theme.spacing()
            }
        })
    };
};
var ResponsiveCardContent = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ResponsiveCardContent, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(ResponsiveCardContent);
    function ResponsiveCardContent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, ResponsiveCardContent);
        return _super.apply(this, arguments);
    }
    var _proto = ResponsiveCardContent.prototype;
    _proto.render = function render() {
        var _props = this.props, children = _props.children, classes = _props.classes, className = _props.className, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_props, [
            "children",
            "classes",
            "className"
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_CardContent__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, rest), {
            className: (0,clsx__WEBPACK_IMPORTED_MODULE_11__["default"])(className, classes.responsive),
            children: children
        }));
    };
    return ResponsiveCardContent;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_12__/* .withStyles */ .D)(styles));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(ResponsiveCardContent));


/***/ }),

/***/ 51838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59106);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var _mui_material_Grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34375);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);









var ResponsiveGridContainer = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ResponsiveGridContainer, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ResponsiveGridContainer);
    function ResponsiveGridContainer() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ResponsiveGridContainer);
        return _super.apply(this, arguments);
    }
    var _proto = ResponsiveGridContainer.prototype;
    _proto.render = function render() {
        var _props = this.props, children = _props.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_props, [
            "children"
        ]);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Grid__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            container: true
        }, rest), {
            spacing: 1,
            children: children
        }));
    };
    return ResponsiveGridContainer;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (ResponsiveGridContainer);


/***/ }),

/***/ 89815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86533);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78391);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61250);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29901);
/* harmony import */ var recompose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62690);
/* harmony import */ var _hocs_with_styles__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5887);







var styles = function(theme) {
    return {
        content: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(2),
            "&:first-child": {
                marginTop: 0
            }
        }
    };
};
var TextContentArea = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(TextContentArea, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(TextContentArea);
    function TextContentArea() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, TextContentArea);
        return _super.apply(this, arguments);
    }
    var _proto = TextContentArea.prototype;
    _proto.render = function render() {
        var _props = this.props, classes = _props.classes, children = _props.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classes.content,
            children: children
        });
    };
    return TextContentArea;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);
var enhance = (0,recompose__WEBPACK_IMPORTED_MODULE_2__/* .compose */ .qC)((0,_hocs_with_styles__WEBPACK_IMPORTED_MODULE_6__/* .withStyles */ .D)(styles));
/* harmony default export */ __webpack_exports__["Z"] = (enhance(TextContentArea));


/***/ }),

/***/ 14854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ andon; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(61250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@apollo+client@3.4.0-rc.0_graphql@16.6.0_react@17.0.2/node_modules/@apollo/client/index.js
var client = __webpack_require__(62523);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(29901);
// EXTERNAL MODULE: ./components/loading/loading-or-error.tsx
var loading_or_error = __webpack_require__(89879);
// EXTERNAL MODULE: ./graphql/queries/andon-list-settings.gql
var andon_list_settings = __webpack_require__(32889);
var andon_list_settings_default = /*#__PURE__*/__webpack_require__.n(andon_list_settings);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.5.0/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(88802);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@4cae0a4684a4459d023efab89560fcb90af1aa79_@emotion+react_gy6ly2mjra2l7varjsjqd6sx5u/node_modules/@blackbird/ui-base/dist/es/link/index.js + 2 modules
var es_link = __webpack_require__(6435);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Build.js
var Build = __webpack_require__(55063);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Done.js
var Done = __webpack_require__(77921);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/HelpOutline.js
var HelpOutline = __webpack_require__(93994);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Report.js
var Report = __webpack_require__(6410);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/RingVolume.js
var RingVolume = __webpack_require__(90370);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Avatar/Avatar.js + 1 modules
var Avatar = __webpack_require__(15015);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(78344);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(30985);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(24267);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(34375);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(14724);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tab/Tab.js
var Tab = __webpack_require__(37774);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tabs/Tabs.js + 2 modules
var Tabs = __webpack_require__(57470);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(52875);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(70954);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/red.js
var red = __webpack_require__(16438);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/amber.js
var amber = __webpack_require__(32624);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/colors/green.js
var green = __webpack_require__(21955);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(44143);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/dynamic.js
var dynamic = __webpack_require__(34907);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(82672);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-i18next@11.18.6_i18next@21.10.0_react-dom@17.0.2_react@17.0.2/node_modules/react-i18next/dist/es/Trans.js + 1 modules
var Trans = __webpack_require__(56447);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tss-react@4.8.2_@emotion+react@11.10.6_@emotion+server@11.10.0_react@17.0.2/node_modules/tss-react/esm/mui.js + 15 modules
var mui = __webpack_require__(99109);
// EXTERNAL MODULE: ./components/buttons/scroll-button.tsx
var scroll_button = __webpack_require__(64149);
// EXTERNAL MODULE: ./components/help/help-dialog-stepper.tsx
var help_dialog_stepper = __webpack_require__(89384);
// EXTERNAL MODULE: ./contexts/timepicker.tsx
var timepicker = __webpack_require__(80484);
// EXTERNAL MODULE: ./hooks/use-url-query.ts
var use_url_query = __webpack_require__(55412);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(81401);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(73469);
// EXTERNAL MODULE: ../../node_modules/.pnpm/date-fns@2.29.3/node_modules/date-fns/esm/eachMonthOfInterval/index.js
var eachMonthOfInterval = __webpack_require__(91478);
// EXTERNAL MODULE: ../../node_modules/.pnpm/use-sound@2.2.0_react@17.0.2/node_modules/use-sound/dist/use-sound.esm.js
var use_sound_esm = __webpack_require__(87387);
// EXTERNAL MODULE: ./components/chip-filter/autosuggest-card-header.tsx + 2 modules
var autosuggest_card_header = __webpack_require__(82294);
// EXTERNAL MODULE: ./components/containers/responsive-card-content.tsx
var responsive_card_content = __webpack_require__(86489);
// EXTERNAL MODULE: ./components/containers/responsive-grid-container.tsx
var responsive_grid_container = __webpack_require__(51838);
// EXTERNAL MODULE: ./components/pickers/time-picker.tsx
var time_picker = __webpack_require__(29876);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/LinearProgress/LinearProgress.js
var LinearProgress = __webpack_require__(62471);
// EXTERNAL MODULE: ./hocs/with-clock.tsx
var with_clock = __webpack_require__(83685);
;// CONCATENATED MODULE: ./components/progress-bar.tsx






var useStyles = (0,mui/* makeStyles */.ZL)()(function() {
    return {
        indeterminate: {
            opacity: 0.15
        }
    };
});
var ProgressBar = function(param) {
    var reset = param.reset;
    var ref = (0,react.useState)(Date.now()), baseTime = ref[0], setBaseTime = ref[1];
    var ref1 = (0,react.useState)(0), terminationTime = ref1[0], setTerminationTime = ref1[1];
    var ref2 = (0,react.useContext)(with_clock/* ClockContext */.n_), currentTime = ref2.currentTime, start = ref2.start;
    var ref3 = useStyles(), classes = ref3.classes, cx = ref3.cx;
    (0,react.useEffect)(start, []);
    var now = currentTime.getTime();
    (0,react.useEffect)(function() {
        if (reset) {
            if (baseTime) {
                setTerminationTime(now + (now - baseTime));
            }
            setBaseTime(now);
        }
    }, [
        reset
    ]);
    var determinate = !!terminationTime;
    var progress = !determinate ? 0 : (terminationTime - now) / (terminationTime - baseTime);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinearProgress/* default */.Z, {
        className: cx((0,_define_property/* default */.Z)({}, classes.indeterminate, !determinate)),
        variant: determinate ? "determinate" : "indeterminate",
        value: Math.max(Math.min(Math.floor((1 - progress) * 100), 100), 0)
    });
};
/* harmony default export */ var progress_bar = (ProgressBar);

;// CONCATENATED MODULE: ./contexts/company.tsx

var initialValue = {
    companyId: null
};
var Context = /*#__PURE__*/ (0,react.createContext)(initialValue);
/* harmony default export */ var company = (Context.Provider);

// EXTERNAL MODULE: ./graphql/queries/andon-list-calls.gql
var andon_list_calls = __webpack_require__(62165);
var andon_list_calls_default = /*#__PURE__*/__webpack_require__.n(andon_list_calls);
;// CONCATENATED MODULE: ./sounds/notification.mp3
/* harmony default export */ var notification = (__webpack_require__.p + "static/b55909f4c07f8226c97ff7b35bf3ebf4.mp3");
// EXTERNAL MODULE: ./types/guards.ts
var guards = __webpack_require__(25888);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
;// CONCATENATED MODULE: ../../modules/common/dist/es/embedding.js

var embedSeparator = "ɵ";
var embedSeparatorRegex = new RegExp(embedSeparator, "g");
var embedding_embed = function(source, meta) {
    return [
        source.replace(embedSeparatorRegex, ""),
        JSON.stringify(meta)
    ].join(embedSeparator);
};
var unembed = function(embeddedString) {
    var ref = (0,_sliced_to_array/* default */.Z)(embeddedString.split(embedSeparator), 2), source = ref[0], meta = ref[1];
    var extractedMeta = function() {
        try {
            return meta && JSON.parse(meta);
        } catch (e) {
            return {};
        }
    }();
    return [
        source,
        extractedMeta
    ];
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@4cae0a4684a4459d023efab89560fcb90af1aa79_@emotion+react_gy6ly2mjra2l7varjsjqd6sx5u/node_modules/@blackbird/ui-base/dist/es/index.js + 18 modules
var es = __webpack_require__(59843);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+BlackbirdHQ+module-ui-base@4cae0a4684a4459d023efab89560fcb90af1aa79_@emotion+react_gy6ly2mjra2l7varjsjqd6sx5u/node_modules/@blackbird/ui-base/dist/es/hooks/use-session-storage.js
var use_session_storage = __webpack_require__(73607);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/AccessTime.js
var AccessTime = __webpack_require__(84544);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/OpenInBrowser.js
var OpenInBrowser = __webpack_require__(3319);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableCell/TableCell.js
var TableCell = __webpack_require__(35153);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableRow/TableRow.js
var TableRow = __webpack_require__(65754);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(8942);
// EXTERNAL MODULE: ../generated/graphql/schema.ts
var schema = __webpack_require__(25955);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.21.4_react-dom@17.0.2_react@17.0.2/node_modules/next/router.js
var next_router = __webpack_require__(13515);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(28066);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Send.js
var Send = __webpack_require__(12117);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(57077);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogActions/DialogActions.js
var DialogActions = __webpack_require__(30509);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/DialogContent/DialogContent.js
var DialogContent = __webpack_require__(26561);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/FormControl/FormControl.js
var FormControl = __webpack_require__(91697);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/InputLabel/InputLabel.js
var InputLabel = __webpack_require__(49653);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/MenuItem/MenuItem.js
var MenuItem = __webpack_require__(34756);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Select/Select.js + 1 modules
var Select = __webpack_require__(89900);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TextField/TextField.js
var TextField = __webpack_require__(96620);
// EXTERNAL MODULE: ./components/containers/text-content-area.tsx
var text_content_area = __webpack_require__(89815);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Dialog/Dialog.js
var Dialog = __webpack_require__(67844);
// EXTERNAL MODULE: ./components/dialogs/dialog-header.tsx
var dialog_header = __webpack_require__(60840);
;// CONCATENATED MODULE: ./components/dialogs/andon/header.tsx







var AndonCallDialogHeader = function(param) {
    var onClose = param.onClose, onExited = param.onExited, _maxWidth = param.maxWidth, maxWidth = _maxWidth === void 0 ? "sm" : _maxWidth, children = param.children;
    var theme = (0,useTheme/* default */.Z)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var fullScreen = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("sm"));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dialog/* default */.Z, {
        fullScreen: fullScreen,
        open: true,
        onClose: onClose,
        fullWidth: true,
        maxWidth: maxWidth,
        scroll: "body",
        TransitionProps: {
            onExited: onExited
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dialog_header/* default */.Z, {
                title: t([
                    "andon:call:title"
                ], {
                    defaultValue: "Andon Call"
                }),
                onClose: onClose
            }),
            children
        ]
    });
};
/* harmony default export */ var header = (AndonCallDialogHeader);

// EXTERNAL MODULE: ./graphql/mutations/andon-call-release.gql
var andon_call_release = __webpack_require__(18469);
var andon_call_release_default = /*#__PURE__*/__webpack_require__.n(andon_call_release);
// EXTERNAL MODULE: ./graphql/mutations/andon-call-work-order-initiate.gql
var andon_call_work_order_initiate = __webpack_require__(12846);
var andon_call_work_order_initiate_default = /*#__PURE__*/__webpack_require__.n(andon_call_work_order_initiate);
// EXTERNAL MODULE: ./graphql/queries/andon-list-work-order-keys.gql
var andon_list_work_order_keys = __webpack_require__(84275);
var andon_list_work_order_keys_default = /*#__PURE__*/__webpack_require__.n(andon_list_work_order_keys);
;// CONCATENATED MODULE: ./helpers/andon.tsx



var sortPriority = {
    make: 4,
    take: 3,
    pending: 2,
    resolve: 1
};
var buildSummary = function(action, utils) {
    var actions = Object.entries(action).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), a = _param[1];
        return !!a;
    });
    actions.sort(function(param, param1) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), actionLeft = _param[0], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 1), actionRight = _param1[0];
        return sortPriority[actionRight] - sortPriority[actionLeft];
    });
    var ref = (0,_sliced_to_array/* default */.Z)(actions.reduce(function(param, param1) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), summary = _param[0], previousCallTime = _param[1], _param1 = (0,_sliced_to_array/* default */.Z)(param1, 2), step = _param1[0], ref = _param1[1], author = ref.author, details = ref.details, time = ref.time;
        if (typeof details !== "string") {
            return [
                summary,
                previousCallTime
            ];
        }
        var callTime = new Date(time);
        var timeSinceLastCall = previousCallTime ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
            children: [
                " (",
                utils.formatDistance(previousCallTime, callTime),
                ")"
            ]
        }) : null;
        var ref1 = (0,_sliced_to_array/* default */.Z)(unembed(details), 1), unembeddedDetails = ref1[0];
        var formattedDetails = unembeddedDetails.split("\n").reduce(function(d, part) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    d,
                    part,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                ]
            });
        }, /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}));
        var quotedDetails = step === "take" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("blockquote", {
            children: formattedDetails
        });
        return [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    summary,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("code", {
                        children: [
                            author || "N/A",
                            " "
                        ]
                    }),
                    " at ",
                    [
                        callTime.toLocaleDateString(),
                        callTime.toLocaleTimeString()
                    ].join(", "),
                    timeSinceLastCall,
                    quotedDetails
                ]
            }),
            callTime, 
        ];
    }, [
        /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
        null
    ]), 1), summary = ref[0];
    return summary;
};
var formatTimestamp = function(time) {
    if (!time) {
        return "";
    }
    var date = new Date(time);
    var localeDateString = date.toLocaleDateString();
    var localeTimeString = date.toLocaleTimeString();
    return [
        localeDateString,
        localeTimeString
    ].join(", ");
};

// EXTERNAL MODULE: ./helpers/helper-functions.ts
var helper_functions = __webpack_require__(15608);
// EXTERNAL MODULE: ./hocs/with-utils.tsx
var with_utils = __webpack_require__(81861);
;// CONCATENATED MODULE: ./components/dialogs/andon/call-interaction/lundbeck-resolve-call.tsx































var HISTORY_NOTE_LIMIT = 1500;
var lundbeck_resolve_call_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        iconSizeLeft: {
            color: "inherit",
            height: "1em !important",
            width: "1em !important",
            fontSize: theme.typography.pxToRem(24),
            marginRight: theme.spacing()
        },
        iconSizeRight: {
            color: "inherit",
            height: "1em !important",
            width: "1em !important",
            fontSize: theme.typography.pxToRem(24),
            marginLeft: theme.spacing()
        },
        buttonWithIconRight: {
            "& > span > svg": {
                marginLeft: theme.spacing()
            }
        },
        buttonWithIconLeft: {
            "& > span > svg": {
                marginRight: theme.spacing()
            }
        },
        buttonNegative: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.getContrastText(theme.palette.error.main),
            "&:hover": {
                backgroundColor: theme.palette.error.main
            }
        },
        hideWhileSmall: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            display: "none"
        })
    };
});
var errorCodes = {
    valby: {
        symptomValues: [
            "ANDET",
            "ELEKTRISK",
            "EMBALLAGE",
            "FORSYNING",
            "KALD ANNULLERES",
            "KOMPONENT DEFEKT",
            "KOMPONENT L\xd8S",
            "KOMPONENT STRAM",
            "KOMPONENT TILSTOP.",
            "KOMPONENT UT\xc6T",
            "MEKANISK",
            "NEDSAT YDELSE",
            "OPERAT\xd8R SUPPORT",
            "PRODUKT",
            "PRODUKTIONSFORHOLD",
            "ST\xd8J/VIBRATIONER",
            "UDE AF JUSTERING", 
        ],
        causeValues: [
            "AMPUL",
            "ANDET",
            "BLOKERET",
            "BOOKLET",
            "BRANDALARM",
            "BRUGSER",
            "DESIGN",
            "DR\xc5BER",
            "D\xc6KFOLIE",
            "EKSTERNE FORHOLD",
            "EKSTERNT LYS",
            "F-KASSEETIKET",
            "F-KASSER",
            "FEJL IKKE OBSERV.",
            "FEJLBETJENING",
            "FEJLJUSTERING",
            "FORMFOLIE",
            "FRIKTION",
            "FUGT",
            "F\xd8LERFEJL",
            "IT/SAP",
            "KAPSEL",
            "KARTONETIKET",
            "KARTONNER",
            "KORTSLUTNING",
            "KULDE",
            "K\xd8LEVAND",
            "MANGLENDE OPL\xc6RING",
            "MANGLENDE RENG\xd8R.",
            "MATERIALE / MEDIE",
            "OMSTILLINGSFEJL",
            "OMSTILLINGSHJ\xc6LP",
            "OPERAT\xd8R FEJLRETN.",
            "OVERBELASTET",
            "PIPETTER",
            "PRODUKTETIKET",
            "PROGRAMFEJL",
            "SLITAGE",
            "STR\xc6KFOLIE",
            "STR\xd8M",
            "STYRESYSTEM",
            "ST\xd8J",
            "ST\xd8V / SNAVS",
            "TABLET",
            "TEMPERATUR",
            "TILSTOPNING",
            "TRYK",
            "UDSUGNING",
            "VARME",
            "VENTILATION",
            "VIALS",
            "VIBRATIONER",
            "VISION", 
        ],
        actionValues: [
            "ANDET",
            "DRIFTJUSTERING",
            "GENINDL\xc6ST FORMAT",
            "GRUNDJUSTERING",
            "MASKINE GENSTARTET",
            "N\xd8DREPARERET",
            "OPL\xc6RING",
            "OVERV\xc5GNING",
            "RENGJORT",
            "REPARERET",
            "SM\xd8RING",
            "SOFTWAREOPDATERING",
            "UDSKIFTNING", 
        ]
    },
    valbonne: {
        symptomValues: [
            "ALIGNEMENT COMPRIMES",
            "ALIM. CHEVALETS",
            "ALIM. ETUIS ETUYEUSE",
            "ALIM. ETUIS VIGNETTEUSE",
            "ALIM. FLACONS",
            "ALIM. PANNEAUX",
            "ALIMENTATION CARTONS",
            "ALIMENTATION ELECTRIQUE",
            "ALIMENTATION FARDEAUX",
            "ALIMENTATION PNEUMATIQUE",
            "ALIMENTATION PRODUIT",
            "BUG SYSTEME",
            "CENTRAGE IMPRESSION",
            "CHARGEMENT BLISTERS",
            "CLOTURE LOT",
            "CODE ARTICLE",
            "COLLAGE CHEVALETS",
            "COLLAGE COUVERCLE",
            "COLLAGE ETUIS",
            "COLLAGE PANNEAUX",
            "CONNEXION",
            "CONTROLE CHEVALETS",
            "CONTROLE ETUIS M1",
            "CONTROLE ETUIS M9",
            "CONTROLE IMPRESSION",
            "CONTROLE LANGUETTES",
            "CONTROLE PANNEAUX",
            "CONTROLE PRESENCE COMPRIMES",
            "CONTROLE VIGNETTES",
            "CONTROLES FLACONS",
            "CONTROLES T&T",
            "DECOUPE / PRE-DECOUPE/PRE-CASS",
            "DEPOSE ETIQUETTES FARDEAUX",
            "DEPOSE ETIQUETTES GROUPAGE",
            "DEPOSE ETIQUETTES PRODUIT",
            "DEPOSE ETIQUETTES T&T",
            "DEPOSE VIGNETTES",
            "DEROULEMENT ALUMINIUM",
            "DEROULEMENT FILM",
            "DEROULEMENT PVC",
            "EJECTION BLISTERS",
            "EJECTION ETUIS",
            "EJECTION FARDEAUX",
            "EMPILEMENT ETUIS",
            "ENCAISSAGE FARDEAUX",
            "ENTRAINEMENT PRINCIPAL SYNCHRO",
            "ENTREE FARDEAUX",
            "FERMETURE CARTONS",
            "FERMETURE ETUIS",
            "FORMAGE",
            "GESTION FORMAT",
            "IMPRESSION ETIQUETTES",
            "IMPRESSION ETUIS",
            "IMPRESSION HAPA",
            "INTRODUCTION BLISTERS",
            "INTRODUCTION FARDEAUX",
            "LANCEMENT DONNEES",
            "LECTURE CODES",
            "MAGASIN NOTICES",
            "MIRAGE FLACONS",
            "MISE EN FORME ETUIS",
            "PALETTISATION CARTONS",
            "PESEE ETUIS",
            "PLIAGE NOTICES",
            "PRECHAUFFAGE",
            "PRISE NOTICES",
            "REFROIDISSEMENT",
            "REMPLISSAGE COMPRIMES",
            "SCELLAGE",
            "SCELLAGE FARDEAUX",
            "SECURITE MACHINE",
            "SORTIE ETUIS TRIEUSE",
            "SORTIE ETUIS VIGNETTEUSE",
            "SORTIE FLACONS",
            "SORTIE MACHINE",
            "SORTIE PRODUIT",
            "STABILISATION",
            "TIRAGE LIGNE",
            "TRANSFERT NOTICES",
            "TRANSFERT PRODUIT",
            "TRANSOORT FLACONS",
            "TRANSPORT BLISTERS",
            "TRANSPORT CARTONS CHAINES",
            "TRANSPORT CARTONS ROULEAUX",
            "TRANSPORT ETUIS ETUYEUSE",
            "TRANSPORT ETUIS FARDELEUSE",
            "TRANSPORT ETUIS VIGNETEUSE",
            "TRANSPORT FARDEAUX PALETTISEUR",
            "TRANSPORT FARDEAUX TABLE ACCU.",
            "TRANSPORT NOTICES", 
        ],
        causeValues: [],
        actionValues: []
    }
};
var tagSeparator = ": ";
var AndonLundbeckResolveCallDialog = function(param) {
    var call = param.call, onClose = param.onClose;
    var ref, ref1, ref2, ref3;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref4[0];
    var ref5 = lundbeck_resolve_call_useStyles(), classes = ref5.classes, cx = ref5.cx;
    var utils = (0,with_utils/* useUtils */.n)();
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,client.useLazyQuery)((andon_list_work_order_keys_default()), {
        ssr: false,
        errorPolicy: "ignore"
    }), 2), runAndonListWorkOrderKeys = ref6[0], ref7 = ref6[1], loading = ref7.loading, data = ref7.data;
    var ref8 = (0,_sliced_to_array/* default */.Z)((data === null || data === void 0 ? void 0 : data.andon) || [], 1), andonCompany = ref8[0];
    var tags = (andonCompany === null || andonCompany === void 0 ? void 0 : andonCompany.tags) || [];
    var ref9 = (0,_sliced_to_array/* default */.Z)((andonCompany === null || andonCompany === void 0 ? void 0 : andonCompany.workOrderKeys) || [], 1), key = ref9[0];
    var ref10 = (0,_sliced_to_array/* default */.Z)((call.tags || []).filter(function(tag) {
        return !!tag;
    }), 1), assignedTag = ref10[0];
    var ref11 = (0,_sliced_to_array/* default */.Z)((assignedTag === null || assignedTag === void 0 ? void 0 : assignedTag.value.split(tagSeparator)) || [], 2), baseMachine = ref11[0], baseUnit = ref11[1];
    var baseState = {
        problem: "",
        rootCause: "",
        solution: "",
        initials: "",
        selectedMachine: baseMachine,
        selectedUnit: baseUnit,
        // NOTE: These are known as error_code_1-3 in APIPRO - we embed it in the
        // message.
        symptom: "",
        cause: "",
        action: "",
        submitAttempt: false
    };
    // TODO: Use useReducer instead - state management has become rather complex
    var ref12 = (0,react.useState)(baseState.problem), problem = ref12[0], setProblem = ref12[1];
    var ref13 = (0,react.useState)(baseState.rootCause), rootCause = ref13[0], setRootCause = ref13[1];
    var ref14 = (0,react.useState)(baseState.solution), solution = ref14[0], setSolution = ref14[1];
    var ref15 = (0,react.useState)(baseState.initials), initials = ref15[0], setInitials = ref15[1];
    var ref16 = (0,react.useState)(baseState.selectedMachine), tmp = ref16[0], selectedMachine = tmp === void 0 ? baseState.selectedMachine : tmp, setSelectedMachine = ref16[1];
    var ref17 = (0,react.useState)(baseState.selectedUnit), tmp1 = ref17[0], selectedUnit = tmp1 === void 0 ? baseState.selectedUnit : tmp1, setSelectedUnit = ref17[1];
    var ref18 = (0,react.useState)(baseState.symptom), symptom = ref18[0], setSymptom = ref18[1];
    var ref19 = (0,react.useState)(baseState.cause), cause = ref19[0], setCause = ref19[1];
    var ref20 = (0,react.useState)(baseState.action), action = ref20[0], setAction = ref20[1];
    var ref21 = (0,react.useState)(baseState.submitAttempt), submitAttempt = ref21[0], setSubmitAttempt = ref21[1];
    var selectedTag = tags.find(function(tag) {
        return tag.value === [
            selectedMachine,
            selectedUnit
        ].join(tagSeparator);
    }) || assignedTag;
    var onProblemChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setProblem(event);
    }), []);
    var onRootCauseChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setRootCause(event);
    }), []);
    var onSolutionChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setSolution(event);
    }), []);
    var onInitialsChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setInitials(event);
    }), []);
    var onMachineChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setSelectedMachine(event);
    }), []);
    var onUnitChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setSelectedUnit(event);
    }), []);
    var onSymptomChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setSymptom(event);
    }), []);
    var onCauseChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setCause(event);
    }), []);
    var onActionChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setAction(event);
    }), []);
    var onExited = (0,react.useCallback)(function() {
        var states = [
            [
                setProblem,
                baseState.problem
            ],
            [
                setCause,
                baseState.cause
            ],
            [
                setSolution,
                baseState.solution
            ],
            [
                setInitials,
                baseState.initials
            ],
            [
                setSelectedMachine,
                baseState.selectedMachine
            ],
            [
                setSelectedUnit,
                baseState.selectedUnit
            ],
            [
                setSymptom,
                baseState.symptom
            ],
            [
                setCause,
                baseState.cause
            ],
            [
                setAction,
                baseState.action
            ], 
        ];
        states.forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), setter = _param[0], state = _param[1];
            return setter(function() {
                return state;
            });
        });
    }, []);
    var companyId = (0,react.useContext)(Context).companyId;
    (0,react.useEffect)(function() {
        if (!call.line || !companyId) {
            return;
        }
        return runAndonListWorkOrderKeys({
            variables: {
                companyId: [
                    companyId
                ],
                tagIds: [
                    assignedTag.id
                ],
                lineId: call.line.id
            }
        });
    }, [
        assignedTag,
        (ref = call.line) === null || ref === void 0 ? void 0 : ref.id
    ]);
    var machineUnitMap = tags.reduce(function(acc, tag) {
        var ref = (0,_sliced_to_array/* default */.Z)(tag.value.split(tagSeparator), 2), machine = ref[0], unit = ref[1];
        acc[machine] = acc[machine] || [];
        if (unit) {
            acc[machine].push(unit);
        }
        return acc;
    }, {});
    var ref22 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((andon_call_release_default())), 2), release = ref22[0], ref23 = ref22[1], releasing = ref23.loading;
    var ref24 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((andon_call_work_order_initiate_default())), 2), sendWorkOrder = ref24[0], ref25 = ref24[1], sending = ref25.loading;
    var callAction = call.action.take;
    if (!callAction || !companyId) {
        return null;
    }
    var problemLabel = t([
        "andon:call:lundbeck:problem"
    ], {
        defaultValue: "1. Problem"
    });
    var rootCauseLabel = t([
        "andon:call:lundbeck:rootCause"
    ], {
        defaultValue: "2. Root Cause"
    });
    var solutionLabel = t([
        "andon:call:lundbeck:solution"
    ], {
        defaultValue: "3. Solution"
    });
    var textFields = [
        {
            id: "problem",
            label: problemLabel,
            rows: 4,
            value: problem,
            onChange: onProblemChange,
            required: true,
            multiline: true,
            error: !problem.length
        },
        {
            id: "rootCause",
            label: rootCauseLabel,
            rows: 4,
            value: rootCause,
            onChange: onRootCauseChange,
            required: true,
            multiline: true,
            error: !rootCause.length
        },
        {
            id: "solution",
            label: solutionLabel,
            rows: 4,
            value: solution,
            onChange: onSolutionChange,
            required: true,
            multiline: true,
            error: !solution.length
        },
        {
            id: "initials",
            label: t([
                "shared:initials"
            ], {
                defaultValue: "Initials"
            }),
            rows: 1,
            value: initials,
            onChange: onInitialsChange,
            required: true,
            error: !initials.length
        }, 
    ];
    var unitOptions = machineUnitMap[selectedMachine] || [];
    var site = ((ref1 = call.line) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.description) === null || ref2 === void 0 ? void 0 : ref2.startsWith("641")) ? "valbonne" : "valby";
    var _site = errorCodes[site], _symptomValues = _site.symptomValues, symptomValues = _symptomValues === void 0 ? [] : _symptomValues, _causeValues = _site.causeValues, causeValues = _causeValues === void 0 ? [] : _causeValues, _actionValues = _site.actionValues, actionValues = _actionValues === void 0 ? [] : _actionValues;
    var selectFields = [
        {
            id: "symptom",
            label: t([
                "shared:symptom"
            ], {
                defaultValue: "Symptom"
            }),
            value: symptom,
            onChange: onSymptomChange,
            values: symptomValues
        },
        {
            id: "cause",
            label: t([
                "shared:cause"
            ], {
                defaultValue: "Cause"
            }),
            value: cause,
            onChange: onCauseChange,
            values: causeValues
        },
        {
            id: "action",
            label: t([
                "shared:action"
            ], {
                defaultValue: "Action"
            }),
            value: action,
            onChange: onActionChange,
            values: actionValues
        },
        {
            id: "machine",
            label: t([
                "apipro:machine"
            ], {
                defaultValue: "Machine"
            }),
            value: selectedMachine,
            onChange: onMachineChange,
            values: Object.keys(machineUnitMap)
        },
        {
            id: "unit",
            label: t([
                "apipro:unit"
            ], {
                defaultValue: "Unit"
            }),
            value: unitOptions.length ? selectedUnit : "",
            onChange: onUnitChange,
            values: unitOptions,
            disabled: !unitOptions.length
        }, 
    ];
    var details = [
        problemLabel,
        problem,
        "",
        rootCauseLabel,
        rootCause,
        "",
        solutionLabel,
        solution
    ].join("\n");
    var isTooLong = HISTORY_NOTE_LIMIT <= details.length;
    var embeddedDetails = embedding_embed(details, {
        symptom: symptom,
        cause: cause,
        action: action
    });
    var isValbonne = key === null || key === void 0 ? void 0 : (ref3 = key.key) === null || ref3 === void 0 ? void 0 : ref3.includes("DEP");
    var invalidFields = isValbonne ? !symptom : selectFields.some(function(field) {
        return !field.value;
    });
    var disableButton = textFields.some(function(field) {
        return field.required && field.error;
    }) || invalidFields || !assignedTag || isTooLong;
    var summary = buildSummary(call.action, utils);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header, {
        onClose: onClose,
        onExited: onExited,
        maxWidth: "md",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DialogContent/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 2,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 6,
                            children: [
                                callAction.author ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_content_area/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle2",
                                            children: t([
                                                "andon:call:takenBy"
                                            ], {
                                                defaultValue: "Taken by"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            children: callAction.author
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_content_area/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "subtitle2",
                                            children: t([
                                                "shared:summary"
                                            ], {
                                                defaultValue: "Summary"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            children: summary
                                        })
                                    ]
                                }),
                                textFields.map(function(param, i) {
                                    var id = param.id, label = param.label, rows = param.rows, value = param.value, onChange = param.onChange, required = param.required, multiline = param.multiline, error = param.error;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_content_area/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                            variant: "filled",
                                            fullWidth: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                id: id,
                                                label: label,
                                                rows: rows,
                                                autoFocus: !i,
                                                variant: "outlined",
                                                multiline: multiline,
                                                onChange: onChange,
                                                value: value,
                                                required: required,
                                                error: submitAttempt && error
                                            })
                                        })
                                    }, id);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            item: true,
                            xs: 6,
                            children: [
                                selectFields.map(function(param) {
                                    var id = param.id, label = param.label, value = param.value, onChange = param.onChange, values = param.values, disabled = param.disabled;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_content_area/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FormControl/* default */.Z, {
                                            variant: "filled",
                                            fullWidth: true,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(InputLabel/* default */.Z, {
                                                    children: label
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* default */.Z, {
                                                    variant: "filled",
                                                    value: value,
                                                    onChange: onChange,
                                                    disabled: !!disabled,
                                                    children: values.map(function(item) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                                                            value: item,
                                                            children: item
                                                        }, item.toLowerCase().trim());
                                                    })
                                                })
                                            ]
                                        })
                                    }, id);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(text_content_area/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                        variant: "filled",
                                        fullWidth: true,
                                        focused: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                            label: t([
                                                "andon:apipro:key"
                                            ], {
                                                defaultValue: "Key"
                                            }),
                                            value: loading ? t([
                                                "andon:fetchingKeys"
                                            ], {
                                                defaultValue: "Fetching keys..."
                                            }) : (key === null || key === void 0 ? void 0 : key.key) || t([
                                                "shared:notAvailable"
                                            ], {
                                                defaultValue: "N/A"
                                            }),
                                            disabled: true,
                                            variant: "outlined"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onClose,
                        color: "primary",
                        className: classes.hideWhileSmall,
                        children: t([
                            "shared:close"
                        ], {
                            defaultValue: "Close"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                return [
                                    2,
                                    release({
                                        variables: {
                                            companyId: companyId,
                                            id: call.id
                                        }
                                    })
                                ];
                            });
                        }),
                        color: "primary",
                        variant: "contained",
                        disabled: releasing,
                        className: cx(classes.buttonWithIconLeft, classes.buttonNegative),
                        children: [
                            releasing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                className: cx(classes.iconSizeLeft)
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {}),
                            t([
                                "shared:release"
                            ], {
                                defaultValue: "Release"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                if (!selectedTag) {
                                    return [
                                        2
                                    ];
                                }
                                return [
                                    2,
                                    sendWorkOrder({
                                        variables: {
                                            companyId: companyId,
                                            callId: call.id,
                                            tagId: selectedTag.id,
                                            author: initials,
                                            details: embeddedDetails.valueOf()
                                        }
                                    })
                                ];
                            });
                        }),
                        color: "primary",
                        variant: "contained",
                        disabled: sending || disableButton,
                        className: classes.buttonWithIconRight,
                        children: [
                            t([
                                "andon:apiProCall:resolve"
                            ], {
                                defaultValue: "Send Work Order"
                            }),
                            sending ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                className: cx(classes.iconSizeRight)
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Send/* default */.Z, {})
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var lundbeck_resolve_call = (AndonLundbeckResolveCallDialog);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Schedule.js
var Schedule = __webpack_require__(23628);
;// CONCATENATED MODULE: ./components/dialogs/andon/call-interaction/pending-call.tsx
















var pending_call_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        iconSizeLeft: {
            color: "inherit",
            height: "1em !important",
            width: "1em !important",
            fontSize: theme.typography.pxToRem(24),
            marginRight: theme.spacing()
        },
        iconSizeRight: {
            color: "inherit",
            height: "1em !important",
            width: "1em !important",
            fontSize: theme.typography.pxToRem(24),
            marginLeft: theme.spacing()
        },
        buttonWithIconRight: {
            "& > span > svg": {
                marginLeft: theme.spacing()
            }
        },
        buttonWithIconLeft: {
            "& > span > svg": {
                marginRight: theme.spacing()
            }
        },
        hideWhileSmall: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            display: "none"
        }),
        buttonNegative: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.getContrastText(theme.palette.error.main),
            "&:hover": {
                backgroundColor: theme.palette.error.main
            }
        },
        buttonNeutral: {
            backgroundColor: amber/* default.600 */.Z[600],
            color: theme.palette.getContrastText(amber/* default.600 */.Z[600]),
            "&:hover": {
                backgroundColor: amber/* default.600 */.Z[600]
            }
        },
        buttonPositive: {
            backgroundColor: green/* default.600 */.Z[600],
            color: theme.palette.getContrastText(green/* default.600 */.Z[600]),
            "&:hover": {
                backgroundColor: green/* default.600 */.Z[600]
            }
        }
    };
});
var AndonResolveCallDialog = function(param) {
    var call = param.call, onClose = param.onClose;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var classes = pending_call_useStyles().classes;
    var utils = (0,with_utils/* useUtils */.n)();
    var callAction = call.action.pending;
    if (!callAction) {
        return null;
    }
    var summary = buildSummary(call.action, utils);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header, {
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                children: [
                    callAction.author ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_content_area/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t([
                                    "andon:call:takenBy"
                                ], {
                                    defaultValue: "Taken by"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                children: callAction.author
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_content_area/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t([
                                    "shared:summary"
                                ], {
                                    defaultValue: "Summary"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                children: summary
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onClose,
                        color: "primary",
                        className: classes.hideWhileSmall,
                        children: t([
                            "shared:close"
                        ], {
                            defaultValue: "Close"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        placement: "top",
                        title: t([
                            "andon:workOrder:pending"
                        ], {
                            defaultValue: "A work order has been initiated for this call and it's in a pending state"
                        }),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                disabled: true,
                                color: "primary",
                                variant: "contained",
                                className: classes.buttonWithIconLeft,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Schedule/* default */.Z, {}),
                                    t([
                                        "shared:pending"
                                    ], {
                                        defaultValue: "Pending..."
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pending_call = (AndonResolveCallDialog);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Refresh.js
var Refresh = __webpack_require__(22748);
// EXTERNAL MODULE: ./graphql/mutations/andon-call-reopen.gql
var andon_call_reopen = __webpack_require__(62650);
var andon_call_reopen_default = /*#__PURE__*/__webpack_require__.n(andon_call_reopen);
;// CONCATENATED MODULE: ./components/dialogs/andon/call-interaction/reopen-call.tsx























var reopen_call_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        iconSizeLeft: {
            color: "inherit",
            height: "1em !important",
            width: "1em !important",
            fontSize: theme.typography.pxToRem(24),
            marginRight: theme.spacing()
        },
        iconSizeRight: {
            color: "inherit",
            height: "1em !important",
            width: "1em !important",
            fontSize: theme.typography.pxToRem(24),
            marginLeft: theme.spacing()
        },
        buttonWithIconRight: {
            "& > span > svg": {
                marginLeft: theme.spacing()
            }
        },
        buttonWithIconLeft: {
            "& > span > svg": {
                marginRight: theme.spacing()
            }
        },
        hideWhileSmall: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            display: "none"
        }),
        buttonNeutral: {
            backgroundColor: amber/* default.600 */.Z[600],
            color: theme.palette.getContrastText(amber/* default.600 */.Z[600]),
            "&:hover": {
                backgroundColor: amber/* default.600 */.Z[600]
            }
        }
    };
});
var reopen_call_AndonResolveCallDialog = function(param) {
    var call = param.call, onClose = param.onClose, frozen = param.frozen;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var ref1 = reopen_call_useStyles(), classes = ref1.classes, cx = ref1.cx;
    var utils = (0,with_utils/* useUtils */.n)();
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((andon_call_reopen_default())), 2), reopen = ref2[0], ref3 = ref2[1], opening = ref3.loading;
    var companyId = (0,react.useContext)(Context).companyId;
    var callAction = call.action.resolve;
    if (!callAction || !companyId) {
        return null;
    }
    var summary = buildSummary(call.action, utils);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header, {
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                children: [
                    callAction.author ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_content_area/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t([
                                    "andon:call:resolvedBy"
                                ], {
                                    defaultValue: "Resolved by"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                children: callAction.author
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_content_area/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t([
                                    "shared:summary"
                                ], {
                                    defaultValue: "Summary"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                children: summary
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onClose,
                        color: "primary",
                        className: classes.hideWhileSmall,
                        children: t([
                            "shared:close"
                        ], {
                            defaultValue: "Close"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                        placement: "top",
                        title: frozen ? t([
                            "andon:workOrder:pending"
                        ], {
                            defaultValue: "A work order has been initiated for this call and it's in a pending state"
                        }) : "",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                                onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        return [
                                            2,
                                            reopen({
                                                variables: {
                                                    companyId: companyId,
                                                    id: call.id,
                                                    resolutionTime: callAction.time
                                                }
                                            })
                                        ];
                                    });
                                }),
                                disabled: frozen,
                                color: "primary",
                                variant: "contained",
                                className: cx(classes.buttonWithIconLeft, classes.buttonNeutral),
                                children: [
                                    opening ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                        className: classes.iconSizeLeft
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Refresh/* default */.Z, {}),
                                    t([
                                        "shared:reopen"
                                    ], {
                                        defaultValue: "Re-open"
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var reopen_call = (reopen_call_AndonResolveCallDialog);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Check.js
var Check = __webpack_require__(69852);
// EXTERNAL MODULE: ./graphql/mutations/andon-call-resolve.gql
var andon_call_resolve = __webpack_require__(95039);
var andon_call_resolve_default = /*#__PURE__*/__webpack_require__.n(andon_call_resolve);
;// CONCATENATED MODULE: ./components/dialogs/andon/call-interaction/resolve-call.tsx


























var resolve_call_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        iconSizeLeft: {
            color: "inherit",
            height: "1em !important",
            width: "1em !important",
            fontSize: theme.typography.pxToRem(24),
            marginRight: theme.spacing()
        },
        iconSizeRight: {
            color: "inherit",
            height: "1em !important",
            width: "1em !important",
            fontSize: theme.typography.pxToRem(24),
            marginLeft: theme.spacing()
        },
        buttonWithIconRight: {
            "& > span > svg": {
                marginLeft: theme.spacing()
            }
        },
        buttonWithIconLeft: {
            "& > span > svg": {
                marginRight: theme.spacing()
            }
        },
        hideWhileSmall: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            display: "none"
        }),
        buttonNegative: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.getContrastText(theme.palette.error.main),
            "&:hover": {
                backgroundColor: theme.palette.error.main
            }
        },
        buttonNeutral: {
            backgroundColor: amber/* default.600 */.Z[600],
            color: theme.palette.getContrastText(amber/* default.600 */.Z[600]),
            "&:hover": {
                backgroundColor: amber/* default.600 */.Z[600]
            }
        },
        buttonPositive: {
            backgroundColor: green/* default.600 */.Z[600],
            color: theme.palette.getContrastText(green/* default.600 */.Z[600]),
            "&:hover": {
                backgroundColor: green/* default.600 */.Z[600]
            }
        }
    };
});
var resolve_call_AndonResolveCallDialog = function(param) {
    var call = param.call, onClose = param.onClose;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var ref1 = resolve_call_useStyles(), classes = ref1.classes, cx = ref1.cx;
    var utils = (0,with_utils/* useUtils */.n)();
    var baseState = {
        solution: "",
        initials: "",
        submitAttempt: false
    };
    var ref2 = (0,react.useState)(baseState.solution), solution = ref2[0], setSolution = ref2[1];
    var ref3 = (0,react.useState)(baseState.initials), initials = ref3[0], setInitials = ref3[1];
    var ref4 = (0,react.useState)(baseState.submitAttempt), submitAttempt = ref4[0], setSubmitAttempt = ref4[1];
    var onSolutionChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setSolution(event);
    }), []);
    var onInitialsChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setInitials(event);
    }), []);
    var onExited = (0,react.useCallback)(function() {
        var states = [
            [
                setSolution,
                baseState.solution
            ],
            [
                setInitials,
                baseState.initials
            ], 
        ];
        states.forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), setter = _param[0], state = _param[1];
            return setter(function() {
                return state;
            });
        });
    }, []);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((andon_call_resolve_default())), 2), resolve = ref5[0], ref6 = ref5[1], resolving = ref6.loading;
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((andon_call_release_default())), 2), release = ref7[0], ref8 = ref7[1], releasing = ref8.loading;
    var companyId = (0,react.useContext)(Context).companyId;
    var callAction = call.action.take;
    if (!callAction || !companyId) {
        return null;
    }
    var solutionLabel = t([
        "shared:solution"
    ], {
        defaultValue: "Solution"
    });
    var textFields = [
        {
            id: "solution",
            label: solutionLabel,
            rows: 4,
            value: solution,
            onChange: onSolutionChange,
            required: true,
            multiline: true,
            error: !solution.length
        },
        {
            id: "initials",
            label: t([
                "shared:initials"
            ], {
                defaultValue: "Initials"
            }),
            rows: 1,
            value: initials,
            onChange: onInitialsChange,
            required: true,
            error: !initials.length
        }, 
    ];
    var disableButton = resolving || textFields.some(function(field) {
        return field.required && field.error;
    });
    var summary = buildSummary(call.action, utils);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header, {
        onClose: onClose,
        onExited: onExited,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                children: [
                    callAction.author ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_content_area/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t([
                                    "andon:call:takenBy"
                                ], {
                                    defaultValue: "Taken by"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                children: callAction.author
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_content_area/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t([
                                    "shared:summary"
                                ], {
                                    defaultValue: "Summary"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                children: summary
                            })
                        ]
                    }),
                    textFields.map(function(param) {
                        var id = param.id, label = param.label, rows = param.rows, value = param.value, onChange = param.onChange, required = param.required, multiline = param.multiline, error = param.error;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_content_area/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                variant: "filled",
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    id: id,
                                    label: label,
                                    rows: rows,
                                    autoFocus: true,
                                    variant: "outlined",
                                    multiline: multiline,
                                    onChange: onChange,
                                    value: value,
                                    required: required,
                                    error: submitAttempt && error
                                })
                            })
                        }, id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onClose,
                        color: "primary",
                        className: classes.hideWhileSmall,
                        children: t([
                            "shared:close"
                        ], {
                            defaultValue: "Close"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                return [
                                    2,
                                    release({
                                        variables: {
                                            companyId: companyId,
                                            id: call.id
                                        }
                                    })
                                ];
                            });
                        }),
                        color: "primary",
                        variant: "contained",
                        disabled: releasing,
                        className: cx(classes.buttonWithIconLeft, classes.buttonNegative),
                        children: [
                            releasing ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                className: cx(classes.iconSizeLeft)
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {}),
                            t([
                                "shared:release"
                            ], {
                                defaultValue: "Release"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                return [
                                    2,
                                    resolve({
                                        variables: {
                                            companyId: companyId,
                                            id: call.id,
                                            author: initials,
                                            details: solution
                                        }
                                    })
                                ];
                            });
                        }),
                        disabled: disableButton,
                        color: "primary",
                        variant: "contained",
                        className: cx(classes.buttonWithIconLeft, classes.buttonPositive),
                        children: [
                            resolving ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                className: classes.iconSizeLeft
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {}),
                            t([
                                "shared:resolve"
                            ], {
                                defaultValue: "Resolve"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var resolve_call = (resolve_call_AndonResolveCallDialog);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+icons-material@5.11.16_@mui+material@5.12.0_@types+react@17.0.58_react@17.0.2/node_modules/@mui/icons-material/Cancel.js
var Cancel = __webpack_require__(96741);
// EXTERNAL MODULE: ./graphql/mutations/andon-call-take.gql
var andon_call_take = __webpack_require__(67231);
var andon_call_take_default = /*#__PURE__*/__webpack_require__.n(andon_call_take);
// EXTERNAL MODULE: ./graphql/mutations/andon-call-cancel.gql
var andon_call_cancel = __webpack_require__(36604);
var andon_call_cancel_default = /*#__PURE__*/__webpack_require__.n(andon_call_cancel);
;// CONCATENATED MODULE: ./components/dialogs/andon/call-interaction/take-call.tsx



























var take_call_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    return {
        iconSizeLeft: {
            color: "inherit",
            height: "1em !important",
            width: "1em !important",
            fontSize: theme.typography.pxToRem(24),
            marginRight: theme.spacing()
        },
        iconSizeRight: {
            color: "inherit",
            height: "1em !important",
            width: "1em !important",
            fontSize: theme.typography.pxToRem(24),
            marginLeft: theme.spacing()
        },
        buttonWithIcon: {
            "& > span > svg": {
                marginLeft: theme.spacing()
            }
        },
        buttonWithIconLeft: {
            "& > span > svg": {
                marginRight: theme.spacing()
            }
        },
        hideWhileSmall: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            display: "none"
        }),
        buttonNeutral: {
            backgroundColor: amber/* default.600 */.Z[600],
            color: theme.palette.getContrastText(amber/* default.600 */.Z[600]),
            "&:hover": {
                backgroundColor: amber/* default.600 */.Z[600]
            }
        },
        buttonNegative: {
            backgroundColor: theme.palette.error.main,
            color: theme.palette.getContrastText(theme.palette.error.main),
            "&:hover": {
                backgroundColor: theme.palette.error.main
            }
        },
        buttonPositive: {
            backgroundColor: green/* default.600 */.Z[600],
            color: theme.palette.getContrastText(green/* default.600 */.Z[600]),
            "&:hover": {
                backgroundColor: green/* default.600 */.Z[600]
            }
        }
    };
});
var AndonTakeCallDialog = function(param) {
    var call = param.call, requireInitials = param.requireInitials, onClose = param.onClose;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var ref1 = take_call_useStyles(), classes = ref1.classes, cx = ref1.cx;
    var baseState = {
        initials: "",
        submitAttempt: false
    };
    var ref2 = (0,react.useState)(baseState.initials), initials = ref2[0], setInitials = ref2[1];
    var ref3 = (0,react.useState)(baseState.submitAttempt), submitAttempt = ref3[0], setSubmitAttempt = ref3[1];
    var onInitialsChange = (0,react.useCallback)((0,helper_functions/* guardedCallback */.vw)(function(event) {
        setSubmitAttempt(baseState.submitAttempt);
        return setInitials(event);
    }), []);
    var onExited = (0,react.useCallback)(function() {
        var states = [
            [
                setInitials,
                baseState.initials
            ]
        ];
        states.forEach(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), setter = _param[0], state = _param[1];
            return setter(function() {
                return state;
            });
        });
    }, []);
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((andon_call_take_default())), 2), take = ref4[0], ref5 = ref4[1], taking = ref5.loading;
    var ref6 = (0,_sliced_to_array/* default */.Z)((0,client.useMutation)((andon_call_cancel_default()), {
        refetchQueries: [
            {
                query: (andon_list_calls_default())
            }
        ]
    }), 2), cancel = ref6[0], ref7 = ref6[1], cancelling = ref7.loading;
    var companyId = (0,react.useContext)(Context).companyId;
    var utils = (0,with_utils/* useUtils */.n)();
    var callAction = call.action.make;
    if (!callAction || !companyId) {
        return null;
    }
    var textFields = [
        {
            id: "initials",
            label: t([
                "shared:initials"
            ], {
                defaultValue: "Initials"
            }),
            rows: 1,
            value: initials,
            onChange: onInitialsChange,
            required: requireInitials,
            error: !initials.length
        }, 
    ];
    var disableButton = textFields.some(function(field) {
        return field.required && field.error;
    });
    var summary = buildSummary(call.action, utils);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(header, {
        onClose: onClose,
        onExited: onExited,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogContent/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_content_area/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t([
                                    "andon:call:requestedSupport"
                                ], {
                                    defaultValue: "Requested support"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                children: call.requestedSupport || t([
                                    "shared:any"
                                ], {
                                    defaultValue: "Any"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(text_content_area/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "subtitle2",
                                children: t([
                                    "shared:summary"
                                ], {
                                    defaultValue: "Summary"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                children: summary
                            })
                        ]
                    }),
                    textFields.map(function(param, i) {
                        var id = param.id, label = param.label, rows = param.rows, value = param.value, onChange = param.onChange, required = param.required, error = param.error;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(text_content_area/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControl/* default */.Z, {
                                variant: "filled",
                                fullWidth: true,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    id: id,
                                    label: label,
                                    rows: rows,
                                    autoFocus: i === 0,
                                    variant: "outlined",
                                    onChange: onChange,
                                    value: value,
                                    required: required,
                                    error: submitAttempt && error
                                })
                            })
                        }, id);
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DialogActions/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        onClick: onClose,
                        color: "primary",
                        className: classes.hideWhileSmall,
                        children: t([
                            "shared:close"
                        ], {
                            defaultValue: "Close"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            cancel({
                                                variables: {
                                                    id: call.id,
                                                    companyId: companyId
                                                }
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        onClose();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        variant: "contained",
                        className: cx(classes.buttonWithIconLeft, classes.buttonNegative),
                        children: [
                            cancelling ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                className: classes.iconSizeLeft
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel/* default */.Z, {}),
                            t([
                                "shared:cancel"
                            ], {
                                defaultValue: "Cancel"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (requireInitials && !initials) {
                                            return [
                                                2
                                            ];
                                        }
                                        return [
                                            4,
                                            take({
                                                variables: {
                                                    id: call.id,
                                                    companyId: companyId,
                                                    author: initials
                                                }
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        onClose();
                                        return [
                                            2
                                        ];
                                }
                            });
                        }),
                        color: "primary",
                        variant: "contained",
                        disabled: disableButton,
                        className: cx(classes.buttonWithIconLeft, classes.buttonPositive),
                        children: [
                            taking ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                className: classes.iconSizeLeft
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Check/* default */.Z, {}),
                            t([
                                "shared:take"
                            ], {
                                defaultValue: "Take"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var take_call = (AndonTakeCallDialog);

// EXTERNAL MODULE: ./constants.ts
var constants = __webpack_require__(61431);
;// CONCATENATED MODULE: ./components/dialogs/andon/call-interaction/index.tsx









var callStates = [
    "resolve",
    "pending",
    "take",
    "make"
];
var AndonCallDialog = function(param) {
    var call = param.call, open = param.open, handleOpenClose = param.handleOpenClose;
    var ref;
    var companyId = (0,react.useContext)(Context).companyId;
    if (!call || !open) {
        return null;
    }
    var currentAction = callStates.find(function(state) {
        return !!call.action[state];
    });
    var requireWorkOrder = companyId === constants/* COMPANIES.LUNDBECK */.Z3.LUNDBECK && !!((ref = call.tags) === null || ref === void 0 ? void 0 : ref.length);
    switch(currentAction){
        case "resolve":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(reopen_call, {
                call: call,
                onClose: handleOpenClose,
                frozen: !!call.action.pending
            });
        case "pending":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(pending_call, {
                call: call,
                onClose: handleOpenClose
            });
        case "take":
            if (requireWorkOrder) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(lundbeck_resolve_call, {
                    call: call,
                    onClose: handleOpenClose
                });
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(resolve_call, {
                    call: call,
                    onClose: handleOpenClose
                });
            }
        case "make":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(take_call, {
                call: call,
                onClose: handleOpenClose,
                requireInitials: requireWorkOrder
            });
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: "noop"
            });
    }
};
/* harmony default export */ var call_interaction = (AndonCallDialog);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/Table/Table.js
var Table = __webpack_require__(75774);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableBody/TableBody.js
var TableBody = __webpack_require__(28151);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableFooter/TableFooter.js
var TableFooter = __webpack_require__(51718);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TableHead/TableHead.js
var TableHead = __webpack_require__(81884);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@mui+material@5.12.0_@emotion+react@11.10.6_@emotion+styled@11.10.6_@types+react@17.0.58_react-dom@17.0.2_react@17.0.2/node_modules/@mui/material/TablePagination/TablePagination.js + 1 modules
var TablePagination = __webpack_require__(22590);
// EXTERNAL MODULE: ./components/buttons/export-csv-button.tsx
var export_csv_button = __webpack_require__(73773);
// EXTERNAL MODULE: ./components/buttons/export-excel-button.tsx
var export_excel_button = __webpack_require__(72615);
// EXTERNAL MODULE: ./hocs/with-width.tsx
var with_width = __webpack_require__(74782);
// EXTERNAL MODULE: ./hooks/use-width.ts
var use_width = __webpack_require__(35458);
;// CONCATENATED MODULE: ./components/tables/exportable-paginated.tsx




















var exportable_paginated_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    var _obj;
    return {
        disabledEm: {
            color: theme.palette.action.disabled
        },
        "@keyframes pulseUrgencyCritical": {
            "0%": {
                backgroundColor: red/* default.800 */.Z[800]
            },
            "50%": {
                backgroundColor: red/* default.200 */.Z[200]
            },
            "100%": {
                backgroundColor: red/* default.800 */.Z[800]
            }
        },
        "@keyframes pulseUrgencyMedium": {
            "0%": {
                backgroundColor: amber/* default.600 */.Z[600]
            },
            "50%": {
                backgroundColor: amber/* default.400 */.Z[400]
            },
            "100%": {
                backgroundColor: amber/* default.600 */.Z[600]
            }
        },
        littlePadding: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            "& > *:first-child": {
                paddingLeft: theme.spacing(),
                paddingRight: theme.spacing(0.5)
            },
            "& > *, & > *:last-child": {
                paddingRight: theme.spacing()
            }
        }),
        buttonIsPending: {
            backgroundColor: theme.palette.action.disabled
        },
        buttonInProgress: {
            animationDuration: "3s !important"
        },
        buttonUrgencyCritical: {
            backgroundColor: red/* default.700 */.Z[700],
            animationName: "$pulseUrgencyCritical",
            animationIterationCount: "infinite",
            animationDuration: "750ms"
        },
        backgroundUrgencyCritical: {
            backgroundColor: red/* default.50 */.Z[50]
        },
        buttonUrgencyMedium: {
            backgroundColor: amber/* default.400 */.Z[400],
            animationName: "$pulseUrgencyMedium",
            animationIterationCount: "infinite",
            animationDuration: "750ms"
        },
        backgroundUrgencyMedium: {
            backgroundColor: amber/* default.50 */.Z[50]
        },
        backgroundPending: {
            backgroundImage: "repeating-linear-gradient(-45deg, #f9f7f7, #f9f7f7 10px, rgba(255, 255, 255, 0.075) 10px, rgba(255, 255, 255, 0.075) 20px)"
        },
        buttonResolved: {
            backgroundColor: green/* default.400 */.Z[400]
        },
        noWrap: {
            whiteSpace: "nowrap"
        },
        table: {
            width: "100%",
            // tableLayout: 'fixed',
            overflow: "auto"
        },
        truncate: {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            maxWidth: "25vw"
        },
        stretch: {
            maxWidth: "50vw"
        },
        openInBrowser: {
            paddingRight: theme.spacing(),
            verticalAlign: "text-top"
        },
        exportButtonsAndPagination: (_obj = {
            justifyContent: "space-between",
            alignItems: "center"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            display: "flex"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
            display: "grid-inline"
        }), _obj),
        hideOnMDUp: (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
            display: "none"
        }),
        hideOnSMDown: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            display: "none"
        })
    };
});
var ExportablePaginated = function(props) {
    var ref = exportable_paginated_useStyles(), classes = ref.classes, cx = ref.cx;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)([
        "shared"
    ]), 1), t = ref1[0];
    var rows = props.rows, headers = props.headers, _children = props.children, children = _children === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
        className: cx(classes.littlePadding),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
            align: "center",
            colSpan: headers.length,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                align: "center",
                children: t([
                    "shared:emptyTable"
                ], {
                    defaultValue: "Table is empty."
                })
            })
        })
    }, "empty") : _children, onExport = props.onExport;
    var ref2 = onExport ? onExport() : {
        headers: [],
        data: []
    }, exportHeaders = ref2.headers, exportData = ref2.data;
    var ref3 = (0,react.useState)(25), rowsPerPage = ref3[0], setRowsPerPage = ref3[1];
    var ref4 = (0,react.useState)(0), page = ref4[0], setPage = ref4[1];
    var width = (0,use_width/* useWidth */.z)();
    var isSmallScreen = (0,with_width/* isWidthDown */.Vf)("sm", width);
    var rowsPerPageOptions = isSmallScreen ? [] : [
        5,
        10,
        25
    ];
    var tableContent = rows.length ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function(param) {
        var key = param.key, cells = param.cells, className = param.className;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
            className: cx(className, classes.littlePadding),
            children: cells.map(function(cell) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                    children: cell.children
                }, cell.key);
            })
        }, key);
    }) : children;
    var onChangePage = (0,react.useCallback)(function(_, p) {
        return setPage(p);
    }, []);
    var onChangeRowsPerPage = (0,react.useCallback)(function(param) {
        var value = param.target.value;
        return setRowsPerPage(Number(value));
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
            size: isSmallScreen ? "small" : "medium",
            className: classes.table,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                        className: classes.littlePadding,
                        children: headers.map(function(param) {
                            var key = param.key, align = param.align, label = param.label, className = param.className, width = param.width;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                align: align,
                                className: className,
                                style: {
                                    width: width
                                },
                                children: label
                            }, key);
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableBody/* default */.Z, {
                    children: tableContent
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableFooter/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TablePagination/* default */.Z, {
                            rowsPerPageOptions: rowsPerPageOptions,
                            colSpan: headers.length,
                            count: rows.length,
                            rowsPerPage: rowsPerPage,
                            page: page,
                            onPageChange: onChangePage,
                            onRowsPerPageChange: onChangeRowsPerPage,
                            component: function(param) {
                                var children = param.children;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    colSpan: headers.length,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: classes.exportButtonsAndPagination,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                item: true,
                                                sm: 12,
                                                md: 6,
                                                className: classes.hideOnSMDown,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(export_csv_button/* default */.Z, {
                                                        id: "maintenanceCallsToCsv",
                                                        data: exportData,
                                                        headers: exportHeaders,
                                                        filename: "calls-controls"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(export_excel_button/* default */.Z, {
                                                        id: "maintenanceCallsToExcel",
                                                        t: t,
                                                        data: [
                                                            {
                                                                name: "data",
                                                                data: exportData
                                                            }
                                                        ],
                                                        headers: exportHeaders,
                                                        name: "MaintenanceCall"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                item: true,
                                                sm: 12,
                                                md: 6,
                                                children: children
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                item: true,
                                                sm: 12,
                                                md: 6,
                                                className: classes.hideOnMDUp,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(export_csv_button/* default */.Z, {
                                                        id: "maintenanceCallsToCsv",
                                                        data: exportData,
                                                        headers: exportHeaders,
                                                        filename: "calls-controls"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(export_excel_button/* default */.Z, {
                                                        id: "maintenanceCallsToExcel",
                                                        t: t,
                                                        headers: exportHeaders,
                                                        data: [
                                                            {
                                                                name: "data",
                                                                data: exportData
                                                            }
                                                        ],
                                                        name: "MaintenanceCall"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                });
                            }
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var exportable_paginated = (ExportablePaginated);

;// CONCATENATED MODULE: ./views/andon/table.tsx

































var table_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    var _obj;
    return {
        disabledEm: {
            color: theme.palette.action.disabled
        },
        "@keyframes pulseUrgencyCritical": {
            "0%": {
                backgroundColor: red/* default.800 */.Z[800]
            },
            "50%": {
                backgroundColor: red/* default.200 */.Z[200]
            },
            "100%": {
                backgroundColor: red/* default.800 */.Z[800]
            }
        },
        "@keyframes pulseUrgencyMedium": {
            "0%": {
                backgroundColor: amber/* default.600 */.Z[600]
            },
            "50%": {
                backgroundColor: amber/* default.400 */.Z[400]
            },
            "100%": {
                backgroundColor: amber/* default.600 */.Z[600]
            }
        },
        littlePadding: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            "& > *:first-child": {
                paddingLeft: theme.spacing(),
                paddingRight: theme.spacing(0.5)
            },
            "& > *, & > *:last-child": {
                paddingRight: theme.spacing()
            }
        }),
        buttonIsPending: {
            backgroundColor: theme.palette.action.disabled
        },
        buttonInProgress: {
            animationDuration: "3s !important"
        },
        buttonUrgencyCritical: {
            backgroundColor: red/* default.700 */.Z[700],
            animationName: "$pulseUrgencyCritical",
            animationIterationCount: "infinite",
            animationDuration: "750ms"
        },
        backgroundUrgencyCritical: {
            backgroundColor: red/* default.50 */.Z[50]
        },
        buttonUrgencyMedium: {
            backgroundColor: amber/* default.400 */.Z[400],
            animationName: "$pulseUrgencyMedium",
            animationIterationCount: "infinite",
            animationDuration: "750ms"
        },
        backgroundUrgencyMedium: {
            backgroundColor: amber/* default.50 */.Z[50]
        },
        backgroundPending: {
            backgroundImage: "repeating-linear-gradient(-45deg, #f9f7f7, #f9f7f7 10px, rgba(255, 255, 255, 0.075) 10px, rgba(255, 255, 255, 0.075) 20px)"
        },
        buttonResolved: {
            backgroundColor: green/* default.400 */.Z[400]
        },
        noWrap: {
            whiteSpace: "nowrap"
        },
        table: {
            width: "100%",
            // tableLayout: 'fixed',
            overflow: "auto"
        },
        truncate: {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            maxWidth: "25vw"
        },
        stretch: {
            maxWidth: "50vw"
        },
        openInBrowser: {
            paddingRight: theme.spacing(),
            verticalAlign: "text-top"
        },
        exportButtonsAndPagination: (_obj = {
            justifyContent: "space-between",
            alignItems: "center"
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.up("md"), {
            display: "flex"
        }), (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("md"), {
            display: "grid-inline"
        }), _obj),
        hideOnMDUp: (0,_define_property/* default */.Z)({}, theme.breakpoints.up("md"), {
            display: "none"
        }),
        hideOnSMDown: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            display: "none"
        })
    };
});
var _obj;
var urgency = (_obj = {}, (0,_define_property/* default */.Z)(_obj, schema/* Urgency.CRITICAL */.Tj.CRITICAL, 1), (0,_define_property/* default */.Z)(_obj, schema/* Urgency.MEDIUM */.Tj.MEDIUM, 0), _obj);
var sortCalls = function(left, right) {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var leftMakeTime = new Date(left.action.make.time).getTime();
    var rightMakeTime = new Date(right.action.make.time).getTime();
    var leftTakeTime = new Date((ref = left.action.take) === null || ref === void 0 ? void 0 : ref.time).getTime();
    var rightTakeTime = new Date((ref1 = right.action.take) === null || ref1 === void 0 ? void 0 : ref1.time).getTime();
    var leftResolveTime = new Date((ref2 = left.action.resolve) === null || ref2 === void 0 ? void 0 : ref2.time).getTime();
    var rightResolveTime = new Date((ref3 = right.action.resolve) === null || ref3 === void 0 ? void 0 : ref3.time).getTime();
    var leftPendingTime = new Date((ref4 = left.action.pending) === null || ref4 === void 0 ? void 0 : ref4.time).getTime();
    var rightPendingTime = new Date((ref5 = right.action.pending) === null || ref5 === void 0 ? void 0 : ref5.time).getTime();
    var isResolved = +!!leftResolveTime - +!!rightResolveTime;
    if (isResolved) {
        return isResolved;
    }
    var isPending = +!!leftPendingTime - +!!rightPendingTime;
    if (isPending) {
        return isPending;
    }
    var isTaken = +!!leftTakeTime - +!!rightTakeTime;
    if (isTaken) {
        return isTaken;
    }
    var urgencyDiff = urgency[right.urgency] - urgency[left.urgency];
    if (urgencyDiff) {
        return urgencyDiff;
    }
    var takeTime = rightTakeTime - leftTakeTime;
    if (takeTime) {
        return takeTime;
    }
    var makeTime = rightMakeTime - leftMakeTime;
    if (makeTime) {
        return makeTime;
    }
    return 0;
};
var AndonTable = function(props) {
    var calls = props.calls, filters = props.filters;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref[0];
    var ref1 = table_useStyles(), classes = ref1.classes, cx = ref1.cx;
    var width = (0,use_width/* useWidth */.z)();
    var isSmallScreen = (0,with_width/* isWidthDown */.Vf)("sm", width);
    var availableHeaders = (0,react.useMemo)(function() {
        return {
            action: {
                key: "action",
                label: function() {
                    return t([
                        "shared:action"
                    ], {
                        defaultValue: "Action"
                    });
                },
                align: "right",
                width: "80px"
            },
            line: {
                key: "line",
                label: function() {
                    return t([
                        "shared:location"
                    ], {
                        defaultValue: "Location"
                    });
                },
                className: classes.truncate
            },
            machine: {
                key: "machine",
                label: function() {
                    return t([
                        "shared:machine"
                    ], {
                        defaultValue: "Machine"
                    });
                }
            },
            unit: {
                key: "unit",
                label: function() {
                    return t([
                        "shared:unit"
                    ], {
                        defaultValue: "Unit"
                    });
                },
                hideWhileSmall: true
            },
            callTime: {
                key: "callTime",
                label: function() {
                    return t([
                        "andon:callTime"
                    ], {
                        defaultValue: "Call time"
                    });
                }
            },
            takenTime: {
                key: "takenTime",
                hideWhileSmall: true,
                label: function() {
                    return t([
                        "andon:takenTime"
                    ], {
                        defaultValue: "Taken time"
                    });
                }
            },
            resolveTime: {
                key: "resolveTime",
                hideWhileSmall: true,
                label: function() {
                    return t([
                        "andon:resolveTime"
                    ], {
                        defaultValue: "Resolve time"
                    });
                }
            },
            caller: {
                key: "caller",
                label: function() {
                    return t([
                        "andon:caller"
                    ], {
                        defaultValue: "Caller"
                    });
                },
                hideWhileSmall: true
            },
            taker: {
                key: "taker",
                label: function() {
                    return t([
                        "andon:taker"
                    ], {
                        defaultValue: "Taker"
                    });
                },
                hideWhileSmall: true
            },
            issue: {
                key: "issue",
                label: function() {
                    return t([
                        "shared:issue"
                    ], {
                        defaultValue: "Issue"
                    });
                },
                className: classes.stretch,
                hideWhileSmall: true
            },
            conclusion: {
                key: "conclusion",
                label: function() {
                    return t([
                        "shared:conclusion"
                    ], {
                        defaultValue: "Conclusion"
                    });
                },
                className: classes.stretch,
                hideWhileSmall: true
            },
            workOrder: {
                key: "workOrder",
                label: function() {
                    return t([
                        "apipro:workOrder"
                    ], {
                        defaultValue: "WorkOrder"
                    });
                },
                className: classes.stretch,
                hideWhileSmall: true
            }
        };
    }, [
        classes,
        t
    ]);
    var ref2 = (0,react.useState)(null), selectedCallId = ref2[0], setSelectedCallId = ref2[1];
    var router = (0,next_router.useRouter)();
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,use_session_storage/* useSessionStorage */.Xs)(constants/* SESSION_STORAGE_LINES_NAVIGATION_OVERVIEW_SEARCH_STATE_KEY */.fs, {}), 2), setSearchState = ref3[1];
    var onNavigateLine = (0,react.useCallback)(function() {
        return setSearchState({
            route: {
                pathname: router.pathname,
                query: router.query
            }
        });
    }, [
        setSearchState
    ]);
    var clearCallSelection = (0,react.useCallback)(function() {
        setSelectedCallId(null);
    }, []);
    var selectedCall = calls.find(function(call) {
        return call.id === selectedCallId;
    });
    var filteredCalls = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(filters.reduce(function(filteredCalls, filter) {
            return filteredCalls.filter(filter);
        }, calls)).sort(sortCalls);
    }, [
        filters,
        calls
    ]);
    var anyTagged = (0,react.useMemo)(function() {
        return filteredCalls.some(function(param) {
            var tags = param.tags;
            return !!(tags === null || tags === void 0 ? void 0 : tags.length);
        });
    }, [
        filteredCalls
    ]);
    var rows = (0,react.useMemo)(function() {
        return filteredCalls.map(function(call) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            var pending = !!(call === null || call === void 0 ? void 0 : (ref = call.action) === null || ref === void 0 ? void 0 : (ref1 = ref.pending) === null || ref1 === void 0 ? void 0 : ref1.time);
            var resolved = !!(call === null || call === void 0 ? void 0 : (ref2 = call.action) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.resolve) === null || ref3 === void 0 ? void 0 : ref3.time);
            // An item cannot be in progress while resolved - this is just to avoid (and ensure) invalid inProgress value.
            var inProgress = !resolved && !!(call === null || call === void 0 ? void 0 : (ref4 = call.action) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.take) === null || ref5 === void 0 ? void 0 : ref5.time);
            var isPending = pending && !resolved;
            var ref8 = (0,_sliced_to_array/* default */.Z)(function() {
                switch(true){
                    case resolved:
                        return [
                            Done/* default */.Z,
                            t([
                                "andon:call:resolved"
                            ], {
                                defaultValue: "This call has been resolved, click to see details"
                            }), 
                        ];
                    case pending:
                        return [
                            AccessTime/* default */.Z,
                            t([
                                "andon:workOrder:pending"
                            ], {
                                defaultValue: "A work order has been initiated for this call and it's in a pending state"
                            }), 
                        ];
                    case inProgress:
                        return [
                            Build/* default */.Z,
                            t([
                                "andon:call:resolve"
                            ], {
                                defaultValue: "Resolve call"
                            })
                        ];
                    default:
                        return [
                            Report/* default */.Z,
                            t([
                                "andon:call:take"
                            ], {
                                defaultValue: "Take call"
                            })
                        ];
                }
            }(), 2), IconComponent = ref8[0], actionMessage = ref8[1];
            var isCritical = call.urgency === schema/* Urgency.CRITICAL */.Tj.CRITICAL;
            var _obj;
            var buttonClass = cx((_obj = {}, (0,_define_property/* default */.Z)(_obj, classes.buttonResolved, resolved), (0,_define_property/* default */.Z)(_obj, classes.buttonUrgencyCritical, isCritical && !resolved && !isPending), (0,_define_property/* default */.Z)(_obj, classes.buttonUrgencyMedium, !isCritical && !resolved && !isPending), (0,_define_property/* default */.Z)(_obj, classes.buttonInProgress, inProgress), (0,_define_property/* default */.Z)(_obj, classes.buttonIsPending, isPending), _obj));
            var _obj1;
            var backgroundClass = cx((_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, classes.backgroundUrgencyCritical, isCritical && !resolved && !inProgress), (0,_define_property/* default */.Z)(_obj1, classes.backgroundUrgencyMedium, !isCritical && !resolved && !inProgress), (0,_define_property/* default */.Z)(_obj1, classes.backgroundPending, isPending), _obj1));
            var cells = [];
            cells.push({
                key: "action",
                // className: classes.noWrap,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    placement: "left",
                    title: actionMessage,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: buttonClass,
                        variant: "contained",
                        color: "primary",
                        onClick: function() {
                            return setSelectedCallId(call.id);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(IconComponent, {})
                    })
                })
            }, {
                key: "line",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                    title: call.line ? t([
                        "shared:openLine"
                    ], {
                        defaultValue: "Open line"
                    }) : "",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        onClick: onNavigateLine,
                        className: classes.truncate,
                        children: call.line ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(es/* Link */.rU, {
                            href: {
                                pathname: "/line",
                                query: {
                                    lineId: call.line.id,
                                    tab: "register-stops"
                                }
                            },
                            children: [
                                isSmallScreen ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: classes.openInBrowser,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenInBrowser/* default */.Z, {
                                        fontSize: "small"
                                    })
                                }),
                                call.line.name
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                            className: classes.disabledEm,
                            children: t([
                                "shared:deleted"
                            ], {
                                defaultValue: "Deleted"
                            })
                        })
                    })
                })
            });
            var ref9 = (0,_sliced_to_array/* default */.Z)(call.tags || [], 1), tag = ref9[0];
            if (anyTagged) {
                var na = t([
                    "shared:notAvailable"
                ], {
                    defaultValue: "N/A"
                });
                var ref10 = (0,_sliced_to_array/* default */.Z)((tag === null || tag === void 0 ? void 0 : tag.value.split(":")) || [], 2), tmp = ref10[0], machine = tmp === void 0 ? na : tmp, tmp1 = ref10[1], unit = tmp1 === void 0 ? na : tmp1;
                cells.push({
                    key: [
                        "machine",
                        call.id
                    ].join("-"),
                    children: machine
                }, {
                    key: [
                        "unit",
                        call.id
                    ].join("-"),
                    children: unit
                });
            }
            cells.push({
                key: [
                    "makeTime",
                    call.id
                ].join("-"),
                children: formatTimestamp(call === null || call === void 0 ? void 0 : (ref6 = call.action) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.make) === null || ref7 === void 0 ? void 0 : ref7.time)
            });
            if (!isSmallScreen) {
                var ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24;
                var ref25;
                var ref26 = (0,_sliced_to_array/* default */.Z)(unembed((ref25 = call === null || call === void 0 ? void 0 : (ref11 = call.action) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.pending) === null || ref12 === void 0 ? void 0 : ref12.details) !== null && ref25 !== void 0 ? ref25 : ""), 1), unembeddedPendingDetails = ref26[0];
                var ref27, ref28, ref29;
                cells.push({
                    key: [
                        "takeTime",
                        call.id
                    ].join("-"),
                    children: formatTimestamp(call === null || call === void 0 ? void 0 : (ref13 = call.action) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.take) === null || ref14 === void 0 ? void 0 : ref14.time)
                }, {
                    key: [
                        "resolveTime",
                        call.id
                    ].join("-"),
                    children: formatTimestamp(call === null || call === void 0 ? void 0 : (ref15 = call.action) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.resolve) === null || ref16 === void 0 ? void 0 : ref16.time)
                }, {
                    key: [
                        "caller",
                        call.id
                    ].join("-"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: cx(classes.truncate, classes.noWrap),
                        children: (ref27 = call === null || call === void 0 ? void 0 : (ref17 = call.action) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.make) === null || ref18 === void 0 ? void 0 : ref18.author) !== null && ref27 !== void 0 ? ref27 : ""
                    })
                }, {
                    key: [
                        "taker",
                        call.id
                    ].join("-"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: cx(classes.truncate, classes.noWrap),
                        children: (ref28 = call === null || call === void 0 ? void 0 : (ref19 = call.action) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.take) === null || ref20 === void 0 ? void 0 : ref20.author) !== null && ref28 !== void 0 ? ref28 : ""
                    })
                }, {
                    key: [
                        "issue",
                        call.id
                    ].join("-"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        children: (ref29 = call === null || call === void 0 ? void 0 : (ref21 = call.action) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.make) === null || ref22 === void 0 ? void 0 : ref22.details) !== null && ref29 !== void 0 ? ref29 : null
                    })
                }, {
                    key: [
                        "conclusion",
                        call.id
                    ].join("-"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        children: [
                            unembeddedPendingDetails ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    unembeddedPendingDetails,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }) : null,
                            (call === null || call === void 0 ? void 0 : (ref23 = call.action) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.resolve) === null || ref24 === void 0 ? void 0 : ref24.details) || null
                        ]
                    })
                });
            }
            return {
                key: call.id,
                className: backgroundClass,
                cells: cells
            };
        });
    }, [
        filteredCalls,
        isSmallScreen
    ]);
    var headers = (0,react.useMemo)(function() {
        return [
            availableHeaders.action,
            availableHeaders.line,
            anyTagged ? availableHeaders.machine : [],
            anyTagged ? availableHeaders.unit : [],
            availableHeaders.callTime,
            isSmallScreen ? [] : availableHeaders.takenTime,
            isSmallScreen ? [] : availableHeaders.resolveTime,
            isSmallScreen ? [] : availableHeaders.caller,
            isSmallScreen ? [] : availableHeaders.taker,
            isSmallScreen ? [] : availableHeaders.issue,
            isSmallScreen ? [] : availableHeaders.conclusion, 
        ].flatMap(function(header) {
            if (Array.isArray(header)) {
                return header;
            }
            var label = header.label, attributes = (0,_object_without_properties/* default */.Z)(header, [
                "label"
            ]);
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, attributes), {
                label: label()
            });
        });
    }, [
        anyTagged,
        isSmallScreen
    ]);
    var onExport = (0,react.useCallback)(function() {
        return {
            headers: [
                {
                    label: t("shared:identifier", {
                        defaultValue: "Identifier"
                    }),
                    key: "id"
                },
                {
                    label: t("andon:callTimestamp", {
                        defaultValue: "Call Timestamp"
                    }),
                    key: "callTime"
                },
                {
                    label: t("andon:takenTimestamp", {
                        defaultValue: "Taken Timestamp"
                    }),
                    key: "takeTime"
                },
                {
                    label: t("andon:waitDurationMinutes", {
                        defaultValue: "Wait Duration (min)"
                    }),
                    key: "waitDuration"
                },
                anyTagged ? {
                    label: t("andon:pendingTimestamp", {
                        defaultValue: "Pending Timestamp"
                    }),
                    key: "pendingTime"
                } : null,
                anyTagged ? {
                    label: t("andon:wordOrderDurationMinutes", {
                        defaultValue: "Work Order Duration (min)"
                    }),
                    key: "workOrderDuration"
                } : null,
                {
                    label: t("andon:resolveTimestamp", {
                        defaultValue: "Resolution Timestamp"
                    }),
                    key: "resolveTime"
                },
                {
                    label: t("andon:resolveDurationMinutes", {
                        defaultValue: "Resolve Duration (min)"
                    }),
                    key: "resolveDuration"
                },
                {
                    label: t("andon:requestedRole", {
                        defaultValue: "Requested Role"
                    }),
                    key: "requestedSupport"
                },
                {
                    label: t("andon:callInitiator", {
                        defaultValue: "Caller"
                    }),
                    key: "caller"
                },
                {
                    label: t("andon:callTaker", {
                        defaultValue: "Taker"
                    }),
                    key: "taker"
                },
                {
                    label: t("shared:issue", {
                        defaultValue: "Issue"
                    }),
                    key: "issue"
                },
                {
                    label: t("shared:conclusion", {
                        defaultValue: "Conclusion"
                    }),
                    key: "conclusion"
                },
                {
                    label: t("andon:urgency", {
                        defaultValue: "Urgency"
                    }),
                    key: "urgency"
                },
                {
                    label: t([
                        "shared:location"
                    ], {
                        defaultValue: "Location"
                    }),
                    key: "location"
                },
                anyTagged ? {
                    label: t("andon:workOrder:name", {
                        defaultValue: "Work Order"
                    }),
                    key: "workOrder"
                } : null, 
            ].filter(function(header) {
                return !!header;
            }),
            data: filteredCalls.map(function(call) {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
                var makeTime = new Date(call.action.make.time).getTime();
                var takeTime = call.action.take && new Date((ref = call.action.take) === null || ref === void 0 ? void 0 : ref.time).getTime();
                var pendingTime = call.action.pending && new Date(call.action.pending.time).getTime();
                var resolveTime = call.action.resolve && new Date(call.action.resolve.time).getTime();
                var waitDuration = typeof takeTime === "number" ? Math.floor((takeTime - makeTime) / 1..minutes) : "";
                var resolveDuration = typeof resolveTime === "number" ? Math.floor((resolveTime - (pendingTime || takeTime)) / 1..minutes) : "";
                var timeOfCall = (0,helper_functions/* excelReadableDateFormat */.xQ)(call.action.make.time);
                var timeTaken = ((ref1 = call.action.take) === null || ref1 === void 0 ? void 0 : ref1.time) ? (0,helper_functions/* excelReadableDateFormat */.xQ)((ref2 = call.action.take) === null || ref2 === void 0 ? void 0 : ref2.time) : "";
                var timeResolved = ((ref3 = call.action.resolve) === null || ref3 === void 0 ? void 0 : ref3.time) ? (0,helper_functions/* excelReadableDateFormat */.xQ)((ref4 = call.action.resolve) === null || ref4 === void 0 ? void 0 : ref4.time) : "";
                var issue = call.action.make.details;
                var ref10 = (0,_sliced_to_array/* default */.Z)(unembed(((ref5 = call.action.pending) === null || ref5 === void 0 ? void 0 : ref5.details) || ""), 2), unembeddedDetails = ref10[0], codes = ref10[1];
                var conclusion = [
                    unembeddedDetails,
                    Object.entries(codes || {}).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                        return "".concat(value, " (").concat(key, ")");
                    }).join(", "),
                    (ref6 = call.action.resolve) === null || ref6 === void 0 ? void 0 : ref6.details, 
                ].join("\n").trim();
                var requestedSupport = ((ref7 = call.role) === null || ref7 === void 0 ? void 0 : ref7.name) || call.requestedSupport || t([
                    "shared:anyone"
                ], {
                    defaultValue: "Anyone"
                }) || "";
                var caller = call.action.make.author;
                var taker = ((ref8 = call.action.take) === null || ref8 === void 0 ? void 0 : ref8.author) || "";
                var ref11;
                var data = {
                    id: call.id,
                    callTime: timeOfCall,
                    takeTime: timeTaken,
                    waitDuration: waitDuration,
                    resolveTime: timeResolved,
                    resolveDuration: resolveDuration,
                    requestedSupport: requestedSupport,
                    caller: caller,
                    taker: taker,
                    issue: issue,
                    conclusion: conclusion,
                    urgency: call.urgency,
                    location: (ref11 = (ref9 = call.line) === null || ref9 === void 0 ? void 0 : ref9.name) !== null && ref11 !== void 0 ? ref11 : ""
                };
                if (anyTagged) {
                    var ref12, ref13;
                    var workOrderDuration = typeof pendingTime === "number" ? Math.floor((pendingTime - makeTime) / 1..minutes) : "";
                    var timePending = ((ref12 = call.action.pending) === null || ref12 === void 0 ? void 0 : ref12.time) ? (0,helper_functions/* excelReadableDateFormat */.xQ)((ref13 = call.action.pending) === null || ref13 === void 0 ? void 0 : ref13.time) : "";
                    var ref14 = (0,_sliced_to_array/* default */.Z)(unembeddedDetails.split(/Work Order: #/), 2), workOrder = ref14[1];
                    data.workOrderDuration = workOrderDuration;
                    data.pendingTime = timePending;
                    data.workOrder = workOrder;
                }
                return data;
            })
        };
    }, [
        filteredCalls
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(exportable_paginated, {
                rows: rows,
                headers: headers,
                onExport: onExport,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                    className: cx(classes.littlePadding),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                        align: "center",
                        colSpan: headers.length,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            align: "center",
                            children: calls.length ? t([
                                "andon:emptyCallTableFiltered"
                            ], {
                                defaultValue: "No Andon calls matches the active filters."
                            }) : t([
                                "andon:emptyCallTable"
                            ], {
                                defaultValue: "No Andon calls have been made."
                            })
                        })
                    })
                }, "empty")
            }),
            selectedCall ? /*#__PURE__*/ (0,jsx_runtime.jsx)(call_interaction, {
                call: selectedCall,
                open: !!selectedCall,
                handleOpenClose: clearCallSelection
            }) : null
        ]
    });
};
/* harmony default export */ var table = (AndonTable);

;// CONCATENATED MODULE: ./views/andon/tabs/calls.tsx
























var getFirstOfMonths = function(from, to) {
    var firstOfMonthsLocal = (0,eachMonthOfInterval/* default */.Z)({
        start: from,
        end: to
    });
    return firstOfMonthsLocal.map(function(firstOfMonth) {
        return new Date(firstOfMonth.getTime() - firstOfMonth.getTimezoneOffset() * 1..minutes);
    });
};
var dependentActions = {
    resolve: "pending",
    pending: "take",
    take: "make"
};
var CallsOverview = function() {
    var ref = (0,react.useContext)(timepicker/* TimepickerContext */.Ai), from = ref.from, to = ref.to;
    var ref1 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)([
        "shared",
        "andon"
    ]), 1), t = ref1[0];
    var allFirstOfMonths = (0,react.useMemo)(function() {
        return getFirstOfMonths(from, to || new Date());
    }, [
        from.getTime(),
        to === null || to === void 0 ? void 0 : to.getTime()
    ]);
    var firstOfMonthsExceptCurrent = allFirstOfMonths.filter(function(firstOfMonth) {
        var now = new Date();
        return now.getUTCFullYear() !== firstOfMonth.getUTCFullYear() || now.getUTCMonth() !== firstOfMonth.getUTCMonth();
    });
    var ref2 = (0,client.useQuery)((andon_list_calls_default()), {
        fetchPolicy: "cache-and-network",
        ssr: false,
        pollInterval: 20..seconds,
        notifyOnNetworkStatusChange: true
    }), data = ref2.data, networkStatus = ref2.networkStatus, fetchMore = ref2.fetchMore;
    (0,react.useEffect)(function() {
        firstOfMonthsExceptCurrent.forEach(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(firstOfMonth) {
                return (0,tslib_es6.__generator)(this, function(_state) {
                    return [
                        2,
                        fetchMore({
                            variables: {
                                time: firstOfMonth
                            }
                        })
                    ];
                });
            });
            return function(firstOfMonth) {
                return _ref.apply(this, arguments);
            };
        }());
    }, [
        from,
        to
    ]);
    var ref3 = (0,_sliced_to_array/* default */.Z)((data === null || data === void 0 ? void 0 : data.andon) || [], 1), primaryAndon = ref3[0];
    var ref4 = primaryAndon || {}, _calls = ref4.calls, calls = _calls === void 0 ? [] : _calls, companyId = ref4.companyId;
    var newestCallTime = (0,react.useMemo)(function() {
        return calls.reduce(function(latestTimestamp, call) {
            return Math.max(latestTimestamp, new Date(call.action.make.time).getTime());
        }, -Infinity);
    }, [
        calls
    ]);
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,use_sound_esm/* default */.Z)(notification), 1), play = ref5[0];
    (0,react.useEffect)(function() {
        if (!Number.isFinite(newestCallTime)) {
            return;
        }
        play();
    }, [
        newestCallTime
    ]);
    var suggestions = (0,react.useMemo)(function() {
        return [
            {
                name: t([
                    "shared:location"
                ], {
                    defaultValue: "Location"
                }),
                key: "lineId",
                type: "OPTIONS",
                justOne: true,
                options: calls.map(function(c) {
                    return c.line;
                }).filter(function(line) {
                    return !!line;
                }).filter(function(line, i, lines) {
                    return lines.findIndex(function(l) {
                        return line.id === l.id;
                    }) === i;
                }).map(function(line) {
                    return {
                        name: line.name,
                        value: line.id
                    };
                })
            },
            {
                name: t([
                    "shared:awaitingAction"
                ], {
                    defaultValue: "Awaiting action"
                }),
                key: "awaitingAction",
                type: "OPTIONS",
                justOne: true,
                options: [
                    {
                        name: t([
                            "andon:take"
                        ], {
                            defaultValue: "Take"
                        }),
                        value: "take"
                    },
                    {
                        name: t([
                            "andon:pending"
                        ], {
                            defaultValue: "Pending"
                        }),
                        value: "pending"
                    },
                    {
                        name: t([
                            "andon:resolve"
                        ], {
                            defaultValue: "Resolve"
                        }),
                        value: "resolve"
                    }, 
                ]
            },
            {
                name: t([
                    "shared:caller"
                ], {
                    defaultValue: "Caller"
                }),
                key: "caller",
                type: "OPTIONS",
                justOne: true,
                options: calls.map(function(c) {
                    return c.action.make.author;
                }).filter(function(author, i, authors) {
                    return authors.findIndex(function(a) {
                        return author.trim().toLowerCase() === a.trim().toLowerCase();
                    }) === i;
                }).map(function(author) {
                    return {
                        name: author,
                        value: author.trim().toLowerCase()
                    };
                })
            },
            {
                name: t([
                    "shared:taker"
                ], {
                    defaultValue: "Taker"
                }),
                key: "taker",
                type: "OPTIONS",
                justOne: true,
                options: calls.map(function(c) {
                    var ref;
                    return (ref = c.action.take) === null || ref === void 0 ? void 0 : ref.author;
                }).filter(function(author) {
                    return !!author;
                }).filter(function(author, i, authors) {
                    return authors.findIndex(function(a) {
                        return author.trim().toLowerCase() === a.trim().toLowerCase();
                    }) === i;
                }).map(function(author) {
                    return {
                        name: author,
                        value: author.trim().toLowerCase()
                    };
                })
            },
            {
                name: t([
                    "shared:resolver"
                ], {
                    defaultValue: "Resolver"
                }),
                key: "resolver",
                type: "OPTIONS",
                justOne: true,
                options: calls.map(function(c) {
                    var ref;
                    return (ref = c.action.resolve) === null || ref === void 0 ? void 0 : ref.author;
                }).filter(function(author) {
                    return !!author;
                }).filter(function(author, i, authors) {
                    return authors.findIndex(function(a) {
                        return author.trim().toLowerCase() === a.trim().toLowerCase();
                    }) === i;
                }).map(function(author) {
                    return {
                        name: author,
                        value: author.trim().toLowerCase()
                    };
                })
            },
            {
                name: t([
                    "andon:requestedRole"
                ], {
                    defaultValue: "Requested Role"
                }),
                key: "requestedRole",
                type: "OPTIONS",
                justOne: true,
                options: calls.map(function(c) {
                    return c.requestedSupport;
                }).filter(function(role) {
                    return !!role;
                }).filter(function(role, i, roles) {
                    return roles.findIndex(function(r) {
                        return role.trim().toLowerCase() === r.trim().toLowerCase();
                    }) === i;
                }).map(function(role) {
                    return {
                        name: role,
                        value: role.trim().toLowerCase()
                    };
                })
            }, 
        ];
    }, [
        t,
        calls
    ]);
    var timeFilter = (0,react.useCallback)(function(call) {
        var actionTime = new Date((call.action.resolve || call.action.pending || call.action.take || call.action.make).time).getTime();
        return from.getTime() <= actionTime && (!to || actionTime <= to.getTime());
    }, [
        from.getTime(),
        to === null || to === void 0 ? void 0 : to.getTime()
    ]);
    var ref6 = (0,react.useState)([]), filters = ref6[0], setFilters = ref6[1];
    var onFilters = (0,react.useCallback)(function(filters) {
        var filteredFilters = filters.filter(function(filter, _, allFilters) {
            if (![
                "machine",
                "unit"
            ].some(function(key) {
                return filter.key === key;
            })) {
                return true;
            }
            return allFilters.some(function(f) {
                return f.key === "lineId";
            });
        });
        setFilters(filteredFilters);
    }, []);
    // NOTE: This is Lundbeck-specific - they are the only one that uses tags for
    // work orders - we may want to redesign that concept at a later point - leave
    // this as is for now, just know that in 99% of the cases the assignment
    // terminates immediately.
    var extendedSuggestions = (0,react.useMemo)(function() {
        if (!filters.some(function(filter) {
            return filter.key === "lineId";
        })) {
            return suggestions;
        }
        if (!calls.some(function(call) {
            var ref;
            return (ref = call.tags) === null || ref === void 0 ? void 0 : ref.length;
        })) {
            return suggestions;
        }
        var extraSuggestions = [];
        var ref = (0,_sliced_to_array/* default */.Z)(calls.map(function(c) {
            return c.tags;
        }).flat().filter(function(tag) {
            return !!tag;
        }).filter(function(tag, i, tags) {
            return tags.findIndex(function(t) {
                return t.id === tag.id;
            }) === i;
        }).reduce(function(param, tag) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), machines = _param[0], units = _param[1];
            var trimmedValue = tag.value.trim();
            var ref = (0,_sliced_to_array/* default */.Z)(trimmedValue.split(": ").map(function(pt) {
                return pt.trim();
            }), 2), machine = ref[0], tmp = ref[1], unit = tmp === void 0 ? "" : tmp;
            machines[machine] = machines[machine] || {
                name: machine,
                value: machine
            };
            // NOTE: We use the tag.value to avoid looking up units scoped under other lines
            var lowerMachine = machine.toLowerCase();
            units[lowerMachine] = units[lowerMachine] || {};
            units[lowerMachine][trimmedValue] = units[lowerMachine][trimmedValue] || {
                name: unit,
                value: trimmedValue
            };
            return [
                machines,
                units
            ];
        }, [
            {},
            {}
        ]), 2), machines = ref[0], units = ref[1];
        extraSuggestions.push({
            name: t([
                "shared:machine"
            ], {
                defaultValue: "Machine"
            }),
            key: "machine",
            type: "OPTIONS",
            justOne: true,
            options: Object.values(machines)
        });
        var filteredMachine = filters.find(function(filter) {
            return filter.key === "machine";
        });
        if (!filteredMachine) {
            return (0,_to_consumable_array/* default */.Z)(suggestions).concat((0,_to_consumable_array/* default */.Z)(extraSuggestions));
        }
        var trimmedMachine = filteredMachine.value.trim();
        extraSuggestions.push({
            name: t([
                "shared:unit"
            ], {
                defaultValue: "Unit"
            }),
            key: "unit",
            type: "OPTIONS",
            justOne: true,
            options: Object.values(units[trimmedMachine] || {})
        });
        return (0,_to_consumable_array/* default */.Z)(suggestions).concat((0,_to_consumable_array/* default */.Z)(extraSuggestions));
    }, [
        filters,
        calls
    ]);
    var filterPredicates = (0,react.useMemo)(function() {
        return (0,_to_consumable_array/* default */.Z)(filters.map(function(param) {
            var key = param.key, value = param.value;
            return function(call) {
                switch(key){
                    case "lineId":
                        var ref;
                        return value === ((ref = call.line) === null || ref === void 0 ? void 0 : ref.id);
                    case "awaitingAction":
                        var dependentAction = guards/* has */.e$(dependentActions, value) ? dependentActions[value] : null;
                        if (!dependentAction) {
                            return false;
                        }
                        return !!call.action[dependentAction] && guards/* has */.e$(call.action, value) && !call.action[value];
                    case "caller":
                        return value.trim().toLowerCase() === call.action.make.author.trim().toLowerCase();
                    case "taker":
                        if (!call.action.take) {
                            return false;
                        }
                        return value.trim().toLowerCase() === call.action.take.author.trim().toLowerCase();
                    case "resolver":
                        if (!call.action.resolve) {
                            return false;
                        }
                        return value.trim().toLowerCase() === call.action.resolve.author.trim().toLowerCase();
                    case "machine":
                    case "unit":
                        return (call.tags || []).some(function(t) {
                            return t === null || t === void 0 ? void 0 : t.value.toLowerCase().includes(value);
                        });
                    case "requestedRole":
                        var ref1;
                        return value.trim().toLowerCase() === ((ref1 = call.requestedSupport) === null || ref1 === void 0 ? void 0 : ref1.trim().toLowerCase());
                    default:
                        return true;
                }
            };
        })).concat([
            timeFilter, 
        ]);
    }, [
        filters,
        timeFilter
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(company, {
        value: {
            companyId: companyId
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(progress_bar, {
                reset: networkStatus === 6
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(responsive_grid_container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(responsive_card_content/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    spacing: 3,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            md: 7,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                mt: 1,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(time_picker/* default */.Z, {})
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            md: 5,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(autosuggest_card_header/* default */.Z, {
                                                suggestions: extendedSuggestions,
                                                applyFilter: onFilters,
                                                t: t,
                                                placeholderText: t([
                                                    "batches:callFilters"
                                                ], {
                                                    defaultValue: "Filter Calls..."
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(table, {
                                    calls: calls,
                                    filters: filterPredicates
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var calls = (CallsOverview);

;// CONCATENATED MODULE: ./views/andon/main.tsx
































var Schedules = dynamic_default()(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        return [
            2,
            Promise.all(/* import() */[__webpack_require__.e(7318), __webpack_require__.e(2742), __webpack_require__.e(7164), __webpack_require__.e(3964), __webpack_require__.e(5377), __webpack_require__.e(4629), __webpack_require__.e(7179), __webpack_require__.e(5379), __webpack_require__.e(9921), __webpack_require__.e(2919), __webpack_require__.e(7766), __webpack_require__.e(8708)]).then(__webpack_require__.bind(__webpack_require__, 27578))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27578)
            ];
        }
    }
});
var Workers = dynamic_default()(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        return [
            2,
            Promise.all(/* import() */[__webpack_require__.e(7318), __webpack_require__.e(2742), __webpack_require__.e(7164), __webpack_require__.e(3964), __webpack_require__.e(5377), __webpack_require__.e(4629), __webpack_require__.e(7179), __webpack_require__.e(4185), __webpack_require__.e(9921), __webpack_require__.e(2919), __webpack_require__.e(7766), __webpack_require__.e(3272)]).then(__webpack_require__.bind(__webpack_require__, 22633))
        ];
    });
}), {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(22633)
            ];
        }
    }
});
var main_useStyles = (0,mui/* makeStyles */.ZL)()(function(theme) {
    var _obj;
    return {
        avatar: {
            margin: 10,
            color: theme.palette.getContrastText(theme.palette.primary.main),
            backgroundColor: theme.palette.primary.main
        },
        headerText: (0,_define_property/* default */.Z)({
            display: "flex",
            alignItems: "center",
            flexShrink: 1,
            marginRight: theme.spacing(4)
        }, theme.breakpoints.down("sm"), {
            marginRight: theme.spacing()
        }),
        headerTabs: (_obj = {
            overflow: "auto",
            display: "flex",
            justifyContent: "center",
            flex: 1
        }, (0,_define_property/* default */.Z)(_obj, theme.breakpoints.down("sm"), {
            order: 10
        }), (0,_define_property/* default */.Z)(_obj, "& > div > div > div::-webkit-scrollbar", {
            display: "none"
        }), (0,_define_property/* default */.Z)(_obj, "& > div > div > div", {
            overflow: "-moz-scrollbars-none",
            "-ms-overflow-style": "none",
            "scrollbar-width": "none"
        }), _obj),
        tab: {
            minWidth: "150px",
            textAlign: "center"
        },
        headerContainer: (0,_define_property/* default */.Z)({
            display: "flex",
            alignItems: "center"
        }, theme.breakpoints.down("md"), {
            flexWrap: "wrap"
        }),
        indicators: (0,_define_property/* default */.Z)({
            display: "flex",
            flexShrink: 1,
            maxWidth: "20%",
            alignItems: "center",
            justifyContent: "flex-end"
        }, theme.breakpoints.down("sm"), {
            maxWidth: "25%",
            flexBasis: "25%"
        }),
        "@keyframes pulseUrgencyCritical": {
            "0%": {
                backgroundColor: red/* default.800 */.Z[800]
            },
            "50%": {
                backgroundColor: red/* default.200 */.Z[200]
            },
            "100%": {
                backgroundColor: red/* default.800 */.Z[800]
            }
        },
        "@keyframes pulseUrgencyMedium": {
            "0%": {
                backgroundColor: amber/* default.600 */.Z[600]
            },
            "50%": {
                backgroundColor: amber/* default.400 */.Z[400]
            },
            "100%": {
                backgroundColor: amber/* default.600 */.Z[600]
            }
        },
        littlePadding: (0,_define_property/* default */.Z)({}, theme.breakpoints.down("md"), {
            "& > *:first-child": {
                paddingLeft: theme.spacing(),
                paddingRight: theme.spacing(0.5)
            },
            "& > *, & > *:last-child": {
                paddingRight: theme.spacing()
            }
        }),
        buttonMargin: {
            marginRight: theme.spacing(),
            margin: theme.spacing(0.5)
        },
        buttonInProgress: {
            animationDuration: "3s !important"
        },
        buttonUrgencyCritical: {
            backgroundColor: red/* default.700 */.Z[700],
            animationName: "pulseUrgencyCritical",
            animationIterationCount: "infinite",
            animationDuration: "750ms"
        },
        backgroundUrgencyCritical: {
            backgroundColor: red/* default.50 */.Z[50]
        },
        buttonUrgencyMedium: {
            backgroundColor: amber/* default.400 */.Z[400],
            animationName: "pulseUrgencyMedium",
            animationIterationCount: "infinite",
            animationDuration: "750ms"
        },
        buttonResolved: {
            backgroundColor: green/* default.400 */.Z[400]
        },
        margin: {
            margin: theme.spacing(0.5)
        }
    };
});
var AndonMain = function(param) {
    var companyId = param.companyId;
    var ref = (0,react.useState)(false), open = ref[0], toggleHelp = ref[1];
    var theme = (0,useTheme/* default */.Z)();
    var ref1 = main_useStyles(), classes = ref1.classes, cx = ref1.cx;
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useTranslation/* useTranslation */.$)(), 1), t = ref2[0];
    var tab = (0,use_url_query/* useURLQuery */.m)().tab;
    var tabsMeta = [
        {
            key: "calls",
            label: t([
                "andon:calls"
            ], {
                defaultValue: "Calls"
            }),
            component: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(calls, {});
            }
        },
        {
            key: "schedules",
            label: t([
                "andon:schedules"
            ], {
                defaultValue: "Schedules"
            }),
            component: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Schedules, {
                    companyId: companyId
                });
            }
        },
        {
            key: "workers",
            label: t([
                "andon:workers"
            ], {
                defaultValue: "Workers"
            }),
            component: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Workers, {
                    companyId: companyId
                });
            }
        }, 
    ];
    var isWidthDown = (0,useMediaQuery/* default */.Z)(theme.breakpoints.down("xl"));
    var selectedTab = Math.max(tabsMeta.findIndex(function(t) {
        return t.key === tab;
    }), 0);
    var _selectedTab = tabsMeta[selectedTab], TabContent = _selectedTab.component;
    var tabs = (0,react.useMemo)(function() {
        return tabsMeta.map(function(param) {
            var key = param.key, label = param.label;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(es_link/* default */.ZP, {
                className: classes.tab,
                href: {
                    query: {
                        tab: key
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* default */.Z, {
                    style: {
                        width: "100%"
                    },
                    label: label
                })
            }, key);
        });
    }, [
        tabsMeta
    ]);
    var helpSteps = [
        {
            title: t([
                "andon:helpTitle"
            ], {
                defaultValue: "Andon Help"
            }),
            component: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Trans/* Trans */.c, {
                    i18nKey: "andon:helpText",
                    children: [
                        "An Andon call is a call for help. Operators often use this when a line requires a technician to fix an issue, hence sometimes refered to as a maintenance call. However, it is not limited to only maintenance calls - you can also call managers etc.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        "All active and resolved Andon call are listed on this page. Click the button to open the call details."
                    ]
                });
            }
        },
        {
            title: t([
                "andon:supportTypes"
            ], {
                defaultValue: "Andon Support Types"
            }),
            component: function() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: cx(classes.buttonUrgencyCritical, classes.buttonMargin),
                                    variant: "contained",
                                    color: "primary",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Report/* default */.Z, {})
                                }),
                                t([
                                    "andon:helpButtonCriticalExplainText"
                                ], {
                                    defaultValue: "Critical call wating to be taken."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: cx(classes.buttonUrgencyMedium, classes.buttonMargin),
                                    variant: "contained",
                                    color: "primary",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Report/* default */.Z, {})
                                }),
                                t([
                                    "andon:helpButtonMediumExplainText"
                                ], {
                                    defaultValue: "Call waiting to be taken."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: cx(classes.buttonInProgress, classes.buttonUrgencyCritical, classes.buttonMargin),
                                    variant: "contained",
                                    color: "primary",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Build/* default */.Z, {})
                                }),
                                t([
                                    "andon:helpButtonCriticalWaitExplainText"
                                ], {
                                    defaultValue: "Critical Call has been taken and is in progress of being resolved."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: cx(classes.buttonInProgress, classes.buttonUrgencyMedium, classes.buttonMargin),
                                    variant: "contained",
                                    color: "primary",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Build/* default */.Z, {})
                                }),
                                t([
                                    "andon:helpButtonWaitExplainText"
                                ], {
                                    defaultValue: "Call has been taken and is in progress of being resolved."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: cx(classes.buttonResolved, classes.buttonMargin),
                                    variant: "contained",
                                    color: "primary",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Done/* default */.Z, {})
                                }),
                                t([
                                    "andon:helpButtonResolvedExplainText"
                                ], {
                                    defaultValue: "Call has been resolved."
                                })
                            ]
                        })
                    ]
                });
            }
        }, 
    ];
    var handleToggleHelp = function() {
        toggleHelp(!open);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(timepicker/* default */.ZP, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                style: {
                    marginBottom: 1 / 2
                },
                spacing: 1,
                alignItems: "stretch",
                justifyContent: "flex-start",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    item: true,
                    xs: 12,
                    sm: 12,
                    md: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                        elevation: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContent/* default */.Z, {
                            className: classes.headerContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.headerText,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                                            className: classes.avatar,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RingVolume/* default */.Z, {})
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h5",
                                            children: t([
                                                "andon:pageTitle"
                                            ], {
                                                defaultValue: "Andon"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                                            "aria-label": "Help",
                                            className: classes.margin,
                                            onClick: handleToggleHelp,
                                            size: "large",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HelpOutline/* default */.Z, {
                                                fontSize: "small"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(help_dialog_stepper/* default */.Z, {
                                            title: t([
                                                "andon:pageTitle"
                                            ], {
                                                defaultValue: "Andon"
                                            }),
                                            steps: helpSteps,
                                            open: open,
                                            onClose: handleToggleHelp
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classes.headerTabs,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs/* default */.Z, {
                                        indicatorColor: "primary",
                                        value: selectedTab,
                                        // variant={isWidthDown ? 'scrollable' : 'fullWidth'}
                                        scrollButtons: true,
                                        ScrollButtonComponent: scroll_button/* default */.Z,
                                        allowScrollButtonsMobile: true,
                                        children: tabs
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            TabContent()
        ]
    });
};
/* harmony default export */ var main = (AndonMain);

;// CONCATENATED MODULE: ./views/andon/andon-page.tsx







var AndonPage = function() {
    var ref = (0,client.useQuery)((andon_list_settings_default()), {
        ssr: false,
        errorPolicy: "all",
        fetchPolicy: "no-cache"
    }), data = ref.data, loading = ref.loading, error = ref.error;
    var ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)((ref1 = data === null || data === void 0 ? void 0 : data.andon) !== null && ref1 !== void 0 ? ref1 : [
        undefined
    ], 1), andonSettings = ref2[0];
    // TODO: We may update the selected company (settings) if that is the desire.
    var ref3 = (0,react.useState)(andonSettings), tmp = ref3[0], settings = tmp === void 0 ? andonSettings : tmp;
    var companyId = (settings || {}).companyId;
    // FIXME: If companyId is undefined here, it means that the Andon service
    // couldn't determine any companies for the current user. In that case, we should
    // render a not-permitted page.
    if (loading || !companyId) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading_or_error/* default */.Z, {
            loading: loading,
            error: error
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main, {
        companyId: companyId
    });
};
/* harmony default export */ var andon_page = (AndonPage);

;// CONCATENATED MODULE: ./pages/andon/index.tsx


var Andon = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(andon_page, {});
};
var __N_SSG = true;
/* harmony default export */ var andon = (Andon);


/***/ }),

/***/ 25888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nr": function() { return /* binding */ isCamera; },
/* harmony export */   "e$": function() { return /* binding */ has; },
/* harmony export */   "rq": function() { return /* binding */ isSensor; }
/* harmony export */ });
/* harmony import */ var generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25955);

var has = function(obj, property) {
    return property in obj;
};
var isSensor = function(peripheral) {
    var ref;
    return ((ref = peripheral === null || peripheral === void 0 ? void 0 : peripheral.peripheralType) !== null && ref !== void 0 ? ref : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .PeripheralType.SENSOR */ .Ti.SENSOR) === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .PeripheralType.SENSOR */ .Ti.SENSOR;
};
var isCamera = function(peripheral) {
    var ref;
    return ((ref = peripheral === null || peripheral === void 0 ? void 0 : peripheral.peripheralType) !== null && ref !== void 0 ? ref : generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .PeripheralType.SENSOR */ .Ti.SENSOR) === generated_graphql_schema__WEBPACK_IMPORTED_MODULE_0__/* .PeripheralType.CAMERA */ .Ti.CAMERA;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,9230,5936,6620,9238,9670,9071,8563,8850,9182,9876,8795,3510,3917,2294,8709,2888,179], function() { return __webpack_exec__(16885); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);